// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-03T20:38:35.183Z
// Property: 8 Metro Station (ID: 5651440852795392)
// Collections: 24 amenities, 15 floorplans (live), 26 photos, 81 POIs, 4 reviews, 3 virtual tours, 6 office hours, 1 special offers (live), 17 faqs
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5695708787113984",
  "multihub_property_id": "5651440852795392",
  "property_external_id": "4837969",
  "property_zillow_url": "https://www.zillow.com/b/8-metro-station-charlotte-nc-5XjX8X/",
  "property_apartments_url": "https://www.apartments.com/8-metro-station-charlotte-nc/dh573cj",
  "property_google_business_url": "https://www.google.com/maps/place/8+Metro+Station/@35.2871399,-80.7592391,15z/data=!4m2!3m1!1s0x0:0xef2971a61f4c4411?sa=X&ved=2ahUKEwj499Oaut_2AhX2gGoFHZ_NBK8Q_BJ6BAglEAU",
  "property_linkedin_url": null,
  "property_hubspot_id": "8443225660",
  "property_crm_software": "Rent Dynamics",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "8-metro-station",
  "property_name": "8 Metro Station",
  "property_website_url": "https://www.8metrostation.com/",
  "property_domain": "https://www.8metrostation.com/",
  "property_address": "5025 Wembley Central Ln",
  "property_full_address": "5025 Wembley Central Ln, Charlotte, NC 28213",
  "property_address_1": "5025 Wembley Central Ln",
  "property_address_2": null,
  "property_address_city": "Charlotte",
  "property_address_state": "NC",
  "property_address_zip_full": "28213-5407",
  "property_address_zip": "28213",
  "property_address_country": "US",
  "property_address_county": "Mecklenburg County",
  "property_neighborhood_address": "Newell South",
  "property_address_latitude": "35.2868089",
  "property_address_longitude": "-80.7571224",
  "property_email": "metrostation@alapts.com",
  "property_phone": "(704) 532-0580",
  "property_call_tracking_phone": "704-610-6251",
  "property_company_name": "American Landmark",
  "property_company_url": "https://www.alapts.com/",
  "agency_contacts": null,
  "property_type": "apartment",
  "property_short_description": "<p><strong>Connected Charlotte living starts at the station.</strong> 8 Metro Station pairs modern one-, two-, and three-bedroom layouts with direct LYNX Blue Line access, polished apartment finishes, and resort-style spaces made for an easier everyday rhythm. <a href=\"/schedule-a-tour\">Schedule a tour</a> to see it firsthand.</p>",
  "property_long_description": "<p><strong>Connected Charlotte living starts at the station.</strong> At 8 Metro Station, you get modern apartment comfort with a true transit advantage: a train lobby and direct access to the LYNX Blue Line at University City Blvd, putting University City, NoDa, Uptown, and South End within easy reach.</p><p>Choose from one- and two-bedroom apartments or spacious three-bedroom townhome-style layouts, then settle into finishes made for everyday ease—chef-inspired kitchens with stainless-steel appliances, granite countertops, tile backsplash, breakfast-bar islands, wood-style flooring, in-home washer and dryer, walk-in closets, and select 10-foot ceilings or patios.</p><p>Outside your door, <a href=\"/amenities\">resort-style amenities</a> add room to recharge: a pool, fitness studio, yoga lawn, cyber café, clubroom, grilling terrace, package concierge, garages, EV charging, bike storage, bark park, and paw spa. Newell South places you near University City shopping and dining, UNC Charlotte Botanical Gardens, RibbonWalk Nature Preserve, and Reedy Creek Nature Center—so your routine can move from city energy to green-space calm without missing a stop.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019e8976-030c-750a-927c-4ea35bbc5bc5.webp",
  "property_featured_image_media": {
    "alt_text": "Resort-style swimming pool with lounge chairs and a poolside building.",
    "public_id": "019e8976-030c-750a-927c-4ea35bbc5bc5",
    "storage_key": "property/5651440852795392/019e8976-030c-750a-927c-4ea35bbc5bc5.webp",
    "width": 1680,
    "height": 1120
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "338",
  "property_year_built": "2019",
  "property_year_renovated": "2021",
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "94.0828402366864",
  "property_admin_fee": "250",
  "property_application_fee": "85",
  "property_fees_deposit_info": "Pet Fee: $400 for 1 Pet, $500 for 2 Pets (Non-Refundable)\nMonthly Pet Rent: $30/pet",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "400",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "30",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Breed restrictions may apply. Contact us for more information.",
  "property_pet_policy_description": "We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $400 for one pet, and $500 total for 2 pets, with a monthly pet rent of $30 per pet. Breed restrictions may apply.",
  "property_petpolicy_info": "We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $400 for one pet, and $500 total for 2 pets, with a monthly pet rent of $30 per pet. Breed restrictions may apply.",
  "property_online_leasing_url": "https://8740313.onlineleasing.realpage.com",
  "property_resident_portal_url": "https://8metrostation.loftliving.com/login",
  "property_apply_now_url": "https://8740313.onlineleasing.realpage.com",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019df5c3-023a-748c-85ce-3d824ecd184c.webp",
  "property_primary_logo_media": {
    "alt_text": "8 Metro Station Premier Apartments logo with a train track graphic.",
    "public_id": "019df5c3-023a-748c-85ce-3d824ecd184c",
    "storage_key": "property/5651440852795392/019df5c3-023a-748c-85ce-3d824ecd184c.webp",
    "width": 3072,
    "height": 3071
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019d02ef-d0be-71ec-8ed3-1966f012467e.webp",
  "property_secondary_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ef-d0be-71ec-8ed3-1966f012467e",
    "storage_key": "property/5651440852795392/019d02ef-d0be-71ec-8ed3-1966f012467e.webp",
    "width": 325,
    "height": 147
  },
  "property_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019df5c2-feb2-776f-aaf5-4e01153097b4.webp",
  "property_icon_media": {
    "alt_text": "Metro Station logo with a large 8 and train tracks.",
    "public_id": "019df5c2-feb2-776f-aaf5-4e01153097b4",
    "storage_key": "property/5651440852795392/019df5c2-feb2-776f-aaf5-4e01153097b4.webp",
    "width": 3072,
    "height": 3071
  },
  "property_fav_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019df5c2-feb2-776f-aaf5-4e01153097b4.webp",
  "property_fav_icon_media": {
    "alt_text": "Metro Station logo with a large 8 and train tracks.",
    "public_id": "019df5c2-feb2-776f-aaf5-4e01153097b4",
    "storage_key": "property/5651440852795392/019df5c2-feb2-776f-aaf5-4e01153097b4.webp",
    "width": 3072,
    "height": 3071
  },
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019df5c2-ff58-75ba-b968-71f807897bd3.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Metro Station Premier Apartments logo with a large 8 and train tracks.",
    "public_id": "019df5c2-ff58-75ba-b968-71f807897bd3",
    "storage_key": "property/5651440852795392/019df5c2-ff58-75ba-b968-71f807897bd3.webp",
    "width": 3072,
    "height": 3071
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019df5c2-fea7-72cc-87a4-dbb62ed17478.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Metro Station Premier Apartments logo.",
    "public_id": "019df5c2-fea7-72cc-87a4-dbb62ed17478",
    "storage_key": "property/5651440852795392/019df5c2-fea7-72cc-87a4-dbb62ed17478.webp",
    "width": 3072,
    "height": 3071
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-af4c-707a-be5f-eaefee6b31cf.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-c9dc-7579-9b73-fbe42f847d6f.webp",
  "property_company_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ed-c9dc-7579-9b73-fbe42f847d6f",
    "storage_key": "company/5695708787113984/019d02ed-c9dc-7579-9b73-fbe42f847d6f.webp",
    "width": 1968,
    "height": 884
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-b73c-7581-ab8a-b01c3434f867.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ed-b73c-7581-ab8a-b01c3434f867",
    "storage_key": "company/5695708787113984/019d02ed-b73c-7581-ab8a-b01c3434f867.webp",
    "width": 2565,
    "height": 1000
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "American Landmark logo on a black background",
    "public_id": "019d02ed-bfec-74fd-b5d0-5a699636306b",
    "storage_key": "company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
    "width": 2565,
    "height": 1000
  },
  "property_primary_color": "#cf4022",
  "property_secondary_color": "#948e8b",
  "property_font_color": "#2e2a25",
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "707 - 1698",
  "property_sqft_min": "707",
  "property_sqft_max": "1698",
  "property_price_range": "1295 - 1560",
  "property_price_min": "1295",
  "property_price_max": "1560",
  "property_available_units": 20,
  "property_facebook_url": "https://www.facebook.com/8metrostationapts",
  "property_instagram_url": "https://www.instagram.com/8metrostation",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJGT02RYkfVIgREURMH6ZxKe8",
  "property_youtube_url": "https://www.youtube.com/@8MetroStation",
  "property_yelp_url": "https://www.yelp.com/biz/8-metro-station-charlotte",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": null,
  "property_home_romance_title": null,
  "property_home_amenities_blurb": "<p><strong>Convenience, comfort, and room to recharge.</strong> At 8 Metro Station, controlled access, elevators, garages, Luxer package lockers, and online resident services keep daily details simple. Beyond your door, switch easily from the fitness center and yoga room to the pool, grill area, lounge, cyber cafe, and outdoor living spaces.</p><p>Inside, chef-inspired kitchens, islands, stainless-style appliances, tile backsplashes, hard floors, in-home laundry, and walk-in closets add polished function to every apartment or townhome-style layout.</p>",
  "property_home_floorplans_blurb": "<p><strong>Choose the layout that matches your routine.</strong> 8 Metro Station offers one- and two-bedroom apartments plus a three-bedroom townhome-style residence in Charlotte, with open kitchens, islands, hard-surface flooring, in-home washer and dryer, and walk-in closets. Select homes add standout extras like tall ceilings or wraparound patio space. Browse featured plans, compare finishes and availability, then schedule a tour to see the details in person.</p>",
  "property_home_gallery_blurb": "<p><strong>Preview life at 8 Metro Station.</strong> Flip through bright kitchens with granite islands and subway tile, living rooms with wood-style floors and balcony views, plus calm bedrooms and walk-in closets. Beyond the apartments, the gallery captures the resort-style pool, fireside seating, grilling terrace, fitness studio, lounge, and the distinctive train-lobby setting that nods to the Blue Line.</p>",
  "property_home_neighborhood_blurb": "<p><strong>Blue Line access, University City energy.</strong> From 8 Metro Station in Newell South, connect on-site to University City Blvd Station for easy rides toward NoDa, Uptown, and South End. Closer to home, The Boardwalk, IKEA, Belgate, and Topgolf keep dining, errands, and downtime within reach.</p><p>For fresh air, explore UNC Charlotte Botanical Gardens or Reedy Creek’s wooded trails, ponds, and disc golf—then see it all on the neighborhood map.</p>",
  "property_home_reviews_blurb": "<p><strong>Reviews that feel like everyday proof.</strong> Residents highlight 8 Metro Station’s clean community, calm atmosphere, and responsive leasing team, with shoutouts for Hanna, Patrick, Grant, and Latoya. Feedback often points to a smooth move-in, friendly support, and a location next to the Blue Line Station with shopping close by. Read the full reviews to see why 8 Metro Station is called a “great place to call your home.”</p>",
  "property_neighborhood_blurb": "<p><strong>Start with the map—then step into it.</strong> In Newell South, 8 Metro Station puts University City energy close without tying every plan to a car. Use the on-site connection to University City Blvd Station for Blue Line rides toward NoDa, Uptown, and South End, or keep plans nearby with lakefront dining at The Boardwalk at University City, errands around IKEA and Belgate, and hangouts at Topgolf Charlotte - University.</p><p>When the day calls for green space, wander the free UNC Charlotte Botanical Gardens or head to Reedy Creek Nature Center and Preserve for wooded trails, disc golf, ponds, and fresh air. Explore the map, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see how easily the neighborhood fits your routine.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Amenities that keep your routine moving.</strong> At 8 Metro Station, everyday convenience is built into the community experience—from controlled access, elevators, garages, and Luxer package lockers to online resident services that make the practical details feel simple.</p><p>When it is time to recharge, move between a fitness center, yoga room, lounge, cyber cafe, pool, grill area, and outdoor living spaces designed for easy downtime. Inside, chef-inspired kitchens with islands, stainless-style appliances, tile backsplashes, hard floors, in-home washer and dryer, and walk-in closets bring polished function to your apartment or townhome-style layout. Select homes add extra breathing room with tall ceilings or wraparound patio space. See more in the <a href=\"/gallery\">amenity gallery</a>, then <a href=\"/schedule-a-tour\">schedule a tour</a> to experience the spaces in person.</p>",
  "property_applynow_blurb": "<p><strong>Ready for connected Charlotte living?</strong> Start your online application for 8 Metro Station and find modern comfort with direct LYNX Blue Line access, one-, two-, and three-bedroom layouts, and everyday finishes like stainless-steel appliances, granite countertops, in-home laundry, and walk-in closets.</p>",
  "property_contactus_blurb": "<p><strong>Have questions or need directions?</strong> Reach out to the 8 Metro Station leasing team for help finding your way to our connected Charlotte apartments with train lobby access to the LYNX Blue Line at University City Blvd. We’re here to make your next step simple.</p>",
  "property_faqs_blurb": "<p><strong>Questions before your next stop?</strong> Find quick answers about 8 Metro Station’s apartment layouts, modern finishes, transit-connected location, leasing details, and everyday community living. If you need anything else, the leasing team is happy to help.</p>",
  "property_floorplans_blurb": "<p><strong>Find the floor plan that fits your day-to-day.</strong> At 8 Metro Station, your options range from streamlined one-bedroom layouts to generous two-bedroom homes and a three-bedroom townhome-style residence, giving you room to choose the setup that works best for your routine in Charlotte. Compare open kitchens with islands, hard-surface flooring, in-home washer and dryer, walk-in closets, and select details like tall ceilings or wraparound patio space as you browse current availability.</p><p>Whether you want a low-maintenance layout, extra separation between bedrooms, or more room to spread out, each plan is designed to make everyday living feel polished and practical. View pricing, availability, and finishes below, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see your preferred layout in person.</p>",
  "property_gallery_blurb": "<p><strong>See the spaces before you step inside.</strong> Browse the gallery for a closer look at 8 Metro Station apartments in Charlotte, from bright kitchens with granite islands and subway tile to living rooms with wood-style floors, large windows, and balcony views. Photos move from calm bedrooms and walk-in closets to the resort-style pool, fireside seating, grilling terrace, fitness studio, and lounge with room to unwind or plug in. You will also spot the polished details that make the community feel connected—clean-lined interiors, inviting outdoor spaces, and a train-lobby setting that brings the Blue Line into the picture. Like what you see? Explore the <a href=\"/amenities\">amenity collection</a>, preview <a href=\"/virtual-tours\">virtual tours</a>, or <a href=\"/schedule-a-tour\">schedule a tour</a> to experience your favorite spaces in person.</p>",
  "property_interactivemap_blurb": "<p><strong>Explore connected Charlotte living.</strong> Use the interactive map to browse available apartments at 8 Metro Station and see how direct LYNX Blue Line access puts University City, NoDa, Uptown, South End, shopping, dining, and nearby green space within easy reach.</p>",
  "property_pets_blurb": "<p><strong>Pet-friendly living, right at home.</strong> At 8 Metro Station, your cat or dog has room to settle in comfortably, with a pet policy that welcomes up to two pets per home and no weight limit. Daily care feels easier with an on-site bark park for quick outdoor breaks, a paw spa for post-adventure cleanups, and apartment finishes like hard-surface flooring that help keep life low-maintenance.</p><p>When you want a change of scenery, explore nearby pet-friendly green space or come back to unwind on the outdoor terrace, by the grilling area, or in a layout that gives everyone room to relax. See more community perks on the <a href=\"/amenities\">amenities page</a>, then <a href=\"/schedule-a-tour\">schedule a tour</a> to picture your pet’s routine here.</p>",
  "property_referafriend_blurb": "<p><strong>Share connected Charlotte living.</strong> Love the train lobby, direct LYNX Blue Line access, modern finishes, and resort-style spaces at 8 Metro Station? Invite a friend to find their next one-, two-, or three-bedroom layout here—and make it even easier to stay connected.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident access starts here.</strong><br>Log in to pay rent, submit maintenance requests, and manage your 8 Metro Station account—so everyday apartment living stays as connected and convenient as the address itself.</p>",
  "property_reviews_blurb": "<p><strong>Real feedback, real day-to-day confidence.</strong> As you read 8 Metro Station reviews, you’ll see residents call out the details that shape everyday living: a clean community, professional service, and quick, helpful support from the leasing team. Names like Hanna, Patrick, Grant, and Latoya stand out in comments praising a smooth move-in process and staff who are “friendly and helpful.”</p><p>Residents also appreciate the connected location next to the Blue Line Station and close to major shopping outlets, along with a community that matches its photos and feels calm to come home to. Explore the ratings below to see why reviewers describe 8 Metro Station as a “great place to call your home.”</p>",
  "property_created_at": "1752256399321",
  "property_scheduletour_blurb": "<p><strong>See connected Charlotte living in motion.</strong> Tour 8 Metro Station and experience modern apartment finishes, spacious layouts, resort-style spaces, and direct LYNX Blue Line access from the train lobby. Schedule your visit today and picture your routine starting right at the station.</p>",
  "property_thankyou_blurb": "<p><strong>Thanks—we’ve received your inquiry.</strong><br>Our leasing team will follow up soon. In the meantime, picture connected Charlotte living at 8 Metro Station, with modern apartment comfort, direct LYNX Blue Line access, and everyday ease from stylish finishes to resort-style spaces.</p>",
  "property_virtualtours_blurb": "<p><strong>Take the walkthrough before you walk through the door.</strong> Explore 8 Metro Station from wherever your Charlotte apartment search starts, with virtual tours that put the details in motion. Step inside the Popular 2BR, 2BA apartment to picture the flow from the kitchen island and hard-surface flooring to the everyday storage and finish details that shape the space.</p><p>Then move through the Fitness Center and Clubhouse to see how your routine can shift from workout mode to lounge time without leaving the community. When you are ready for the full view, compare more <a href=\"/floor-plans\">floor plan options</a>, browse the <a href=\"/gallery\">photo gallery</a>, or <a href=\"/schedule-a-tour\">schedule a tour</a> to experience 8 Metro Station in person.</p>",
  "property_copyright": "2025 All Rights Reserved. 8 Metro Station",
  "property_seo_title_home": "8 Metro Station | Apartments in Charlotte, NC",
  "property_seo_description_home": "Discover your perfect home at 8 Metro Station in Charlotte, NC! Choose from spacious one, two, and three-bedroom floor plans with modern amenities like a chef's kitchen, fitness center, and luxurious pool. Enjoy outdoor living with our grill area and wrap-around patio, plus convenient access gates and online resident services. With features like vaulted ceilings, large walk-in closets, and a yoga room, your lifestyle will thrive in our vibrant community. Find your new home today!",
  "property_seo_title_floorplans": "Floor Plans | 1 - 3 Apartments in Charlotte, NC",
  "property_seo_description_floorplans": "Discover your ideal living space at 8 Metro Station in Charlotte, NC! Explore our diverse selection of one, two, and three-bedroom apartment floor plans designed for comfort and style. Browse our available apartment homes today and find the perfect floor plan that meets your lifestyle needs!",
  "property_seo_title_amenities": "Amenities | Charlotte, NC Apartments for Rent",
  "property_seo_description_amenities": "Discover luxurious living at 8 Metro Station in Charlotte, NC! Explore our diverse floor plans, including spacious one, two, and three-bedroom apartments designed with modern amenities like chef's kitchens, walk-in closets, and tall ceilings. Enjoy exclusive community features such as a state-of-the-art fitness center, relaxing pool, outdoor living spaces, and convenient access gates. With amenities like LUXER package lockers, a yoga room, and online resident services, your comfort and lifestyle are our top priorities. Explore our amazing community amenities and apartment features today!",
  "property_seo_title_gallery": "Gallery | Apartments in Charlotte, NC",
  "property_seo_description_gallery": "Explore life at 8 Metro Station in Charlotte, NC, where your dream apartment awaits! Choose from spacious one, two, or three-bedroom floor plans equipped with modern amenities like chef’s kitchens, hard floors, and large walk-in closets. Enjoy exclusive features including a refreshing pool, fitness center, grill area, and stunning views from select homes. Discover the convenience of our LUXER package locker and online resident services. Picture yourself living here and schedule a tour today to see why 8 Metro Station is the perfect place for your new home!",
  "property_seo_title_virtualtours": "Virtual Tours | 8 Metro Station Apartments",
  "property_seo_description_virtualtours": "Discover your ideal home at 8 Metro Station in Charlotte, NC! Explore our diverse floor plans, featuring one, two, and three-bedroom apartments designed for your comfort and style. Take a virtual tour of our vibrant community and see why we’re the perfect place to call home. Don’t miss out—start your journey today!",
  "property_seo_title_interactivemap": "Interactive Map | 8 Metro Station Apartments",
  "property_seo_description_interactivemap": "Discover your perfect home at 8 Metro Station in Charlotte, NC! Explore our stunning one, two, and three-bedroom floor plans, each designed with modern amenities like chef's kitchens, vaulted ceilings, and walk-in closets. Enjoy community features including a fitness center, pool, outdoor living space, and much more! Use our interactive community map to search available apartments, view pricing, and choose your ideal living space today! Your new home awaits at 8 Metro Station!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Charlotte, NC",
  "property_seo_description_neighborhood": "Discover life at 8 Metro Station in Charlotte, NC! Explore our diverse floor plans, featuring cozy one, two, and three-bedroom apartments. Navigate the vibrant neighborhood with ease—see what's around our community, and uncover local favorites and nearby points of interest. Your perfect Charlotte home awaits!",
  "property_seo_title_contact": "Contact Us | 8 Metro Station",
  "property_seo_description_contact": "\"Discover your perfect home at 8 Metro Station in Charlotte, NC! Explore our range of thoughtfully designed one, two, and three-bedroom floor plans. Have questions? Contact our friendly leasing team today for more information and to schedule a tour!\"",
  "property_seo_title_faqs": "FAQs | Apartments in Charlotte, NC",
  "property_seo_description_faqs": "Discover your new home at 8 Metro Station in Charlotte, NC! Explore our diverse floor plans, including one-, two-, and three-bedroom options, designed with modern amenities like a chef's kitchen, fitness center, and luxurious pool. Our community features top-notch facilities such as LUXER package lockers, a cyber café, yoga room, and outdoor living spaces. Have questions? Browse our FAQs page for all the essential information about our apartments and amenities. Join us at 8 Metro Station today!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Charlotte, NC",
  "property_seo_description_reviews": "\"Discover the charm of 8 Metro Station in Charlotte, NC! Explore our spacious one, two, and three-bedroom apartments featuring top-notch amenities like a state-of-the-art fitness center, relaxing pool, and chef’s kitchens with stylish tile backsplashes. Benefit from conveniences like online resident services, robust security with access gates, and a lush outdoor living space. Check out what our residents love about their community and make 8 Metro Station your new home! Read our resident reviews today!\"",
  "property_seo_title_applynow": "Apply Now | Apartments in Charlotte, NC",
  "property_seo_description_applynow": "Discover your dream home at 8 Metro Station in Charlotte, NC! Choose from our stylish one, two, and three-bedroom floor plans, each featuring luxurious amenities like a chef's kitchen, walk-in closets, and high ceilings. Enjoy community perks including a fitness center, pool, yoga room, and outdoor living spaces. With convenient online resident services and access to a LUXER package locker, living here is a breeze. Apply now and find your new home today!",
  "property_seo_title_residentaccess": "Resident Access | 8 Metro Station",
  "property_seo_description_residentaccess": "\"Welcome to 8 Metro Station in Charlotte, NC! Access your resident portal for convenient rent payments, effortless maintenance scheduling, and exclusive community updates. Get started today!\"",
  "property_seo_title_referafriend": "Refer A Friend | 8 Metro Station",
  "property_seo_description_referafriend": "\"Discover the charm of 8 Metro Station in Charlotte, NC! Refer a friend today and enjoy the benefits of having great neighbors in our vibrant community. Simple, rewarding, and fun—join the 8 Metro Station family now!\"",
  "property_seo_title_scheduletour": "Schedule a Tour | 8 Metro Station",
  "property_seo_description_scheduletour": "\"Experience vibrant city living at 8 Metro Station in Charlotte, NC! Discover modern apartments, top-notch amenities, and a welcoming community. Schedule a tour today and find your perfect home!\"",
  "property_seo_title_privacy": "Privacy Policy | 8 Metro Station",
  "property_seo_description_privacy": "\"Discover 8 Metro Station in Charlotte, NC, where your privacy matters. Explore our Privacy Policy to learn how we protect your information while you enjoy exceptional apartment living. View our privacy policy today!\"",
  "property_seo_title_accessibility": "Website Accessibility | 8 Metro Station",
  "property_seo_description_accessibility": "\"Discover accessibility at 8 Metro Station in Charlotte, NC. Our commitment to digital inclusion ensures that everyone can easily navigate our apartment community. Explore our accessibility statement and see how we provide a welcoming environment for all residents. Learn more today!\"",
  "property_seo_title_sitemap": "Sitemap | 8 Metro Station",
  "property_seo_description_sitemap": "Discover the layout and amenities of 8 Metro Station in Charlotte, NC, with our comprehensive sitemap. Easily navigate through our vibrant apartment community and find your ideal home. Explore now!",
  "property_seo_title_thankyou": "Thank You | 8 Metro Station",
  "property_seo_description_thankyou": "Thank you for reaching out to 8 Metro Station in Charlotte, NC! Your inquiry is important to us. A member of our friendly team will be in touch shortly to assist you in finding your perfect apartment. Stay tuned for exciting updates!",
  "property_seo_title_pets": "Pet Policy | Apartments in Austell, GA\r",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791234319343",
  "amenities": [
    {
      "id": "custom_e1b37aec-e9a8-4f82-99b4-15770bc08bb0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "source": "custom",
      "external_id": "P000000145",
      "title": "LUXER Package Locker",
      "amount": "0.0000",
      "description": "Parcel Pending Package Lockers",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_36e58362-0ad3-416c-89b2-1c96bf7c0e19",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "source": "custom",
      "external_id": "P000000594",
      "title": "Access Gates",
      "amount": "0.0000",
      "description": "Controlled Access Gates",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_844166eb-0e6a-401a-8c65-315d41f0ca23",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "source": "custom",
      "external_id": "P000000597",
      "title": "American Landmark 360",
      "amount": "0.0000",
      "description": "American Landmark 360 Resident Program",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_318765ae-98a3-4a3f-9405-0dd3c14d2a2a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "source": "custom",
      "external_id": "P000000613",
      "title": "Chef`s Kitchen",
      "amount": "0.0000",
      "description": "Gourmet Style Kitchens",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0f814dc1-1fed-49e6-9232-dab11aab14c0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "source": "custom",
      "external_id": "P000000630",
      "title": "Elevators",
      "amount": "0.0000",
      "description": "Elevator Access",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_05dafdfd-4df0-4ac8-ad2f-b597d5f65558",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "source": "custom",
      "external_id": "P000000635",
      "title": "Fitness Center",
      "amount": "0.0000",
      "description": "High Endurance Fitness Studio w/ Peleton Bikes",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_17b5618f-92b3-4eb3-8c15-a96ed96d19df",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "source": "custom",
      "external_id": "P000000640",
      "title": "Garages",
      "amount": "0.0000",
      "description": "Garages & Storage Available",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_aae99b56-9320-4825-b6f2-4ea5f374bb5b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "source": "custom",
      "external_id": "P000000644",
      "title": "Grill Area",
      "amount": "0.0000",
      "description": "Outdoor Grilling & Entertainment Area",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5528a455-cfa1-4d01-ba92-e9e36e9b4938",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "source": "custom",
      "external_id": "P000000646",
      "title": "Hard Floors",
      "amount": "0.0000",
      "description": "Hardwood Inspired Flooring",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_32742673-f530-4ef2-8a3b-a1cd09b5385c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "source": "custom",
      "external_id": "P000000651",
      "title": "Kitchen Appliances",
      "amount": "0.0000",
      "description": "Stainless Steel Appliances",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0c73cbab-a34b-43b3-80d5-6012c134fdeb",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "source": "custom",
      "external_id": "P000000652",
      "title": "Kitchen Islands",
      "amount": "0.0000",
      "description": "Kitchen Island w/ Breakfast Bar*",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_82275d6b-3f90-4db0-8a31-6fa65baf8b99",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "source": "custom",
      "external_id": "P000000660",
      "title": "Online Resident Services",
      "amount": "0.0000",
      "description": "Convenient 24/7 Online Resident Services",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_59f8402c-7d5d-45db-b51a-43dd5f794b51",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "source": "custom",
      "external_id": "P000000669",
      "title": "Pool",
      "amount": "0.0000",
      "description": "Resort-Style Swimming Pool",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ea7129ed-53f5-44b2-8b98-e0a7e5de3b11",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "source": "custom",
      "external_id": "P000000675",
      "title": "Select Homes",
      "amount": "0.0000",
      "description": "*In Select Homes",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_9a95228e-48a9-4051-832c-1d8b3e21103b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "source": "custom",
      "external_id": "P000000695",
      "title": "Tile Backsplash",
      "amount": "0.0000",
      "description": "Decorative Tile Backsplash",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b3c7bd1d-a53b-4699-b698-dfbca8c2103d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "source": "custom",
      "external_id": "P000000696",
      "title": "Townhomes",
      "amount": "0.0000",
      "description": "Townhome Floorplans Available",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8413ed37-3fcb-4ff4-9fe6-6e85bc430375",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "source": "custom",
      "external_id": "P000000704",
      "title": "W&D Included",
      "amount": "0.0000",
      "description": "In-Home Washer and Dryers",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_581ba25e-f573-42e6-8d33-fea3e834720f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "source": "custom",
      "external_id": "P000000705",
      "title": "Walk-In Closet",
      "amount": "0.0000",
      "description": "Generous Walk-In Closets",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a9a6d8e6-acef-4a22-8b97-fcec42f36c3c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "source": "custom",
      "external_id": "P000000712",
      "title": "Yoga Room",
      "amount": "0.0000",
      "description": "Yoga Lawn",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d9328b1d-ac93-4cae-9d4e-d66a0f3fb34d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "source": "custom",
      "external_id": "P000001372",
      "title": "Lounge",
      "amount": "0.0000",
      "description": "Clubroom & Lounge",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1ed21067-6ef1-42e4-81f3-9d056f07a85f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "source": "custom",
      "external_id": "P000002384",
      "title": "Cyber Cafe",
      "amount": "0.0000",
      "description": "Cyber Cafe & WiFi in All Social Spaces",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8dd4b72a-b305-4e08-8308-8fe99b4e069a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "source": "custom",
      "external_id": "P000002459",
      "title": "Outdoor Living",
      "amount": "0.0000",
      "description": "Expansive Outdoor Terrace",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_738c8c0d-9a5b-48bf-96e3-58b0eb02b6ac",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "source": "custom",
      "external_id": "P000000255",
      "title": "Wrap Around Patio",
      "amount": "15.0000",
      "description": "L Shaped Patio",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_aa54e86d-3bb3-4e8e-9fb2-ac9422e5b548",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "source": "custom",
      "external_id": "P000000690",
      "title": "Tall Ceilings",
      "amount": "0.0000",
      "description": "10' Ceilings*",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_03530556-7aa7-481e-8f20-c291d24127ef",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019e8976-1b45-7481-999b-244227eb7dc3.webp",
      "image_media": {
        "alt_text": "Living room with green sofa, armchair, and view into a bedroom.",
        "public_id": "019e8976-1b45-7481-999b-244227eb7dc3",
        "storage_key": "property/5651440852795392/019e8976-1b45-7481-999b-244227eb7dc3.webp",
        "width": 2665,
        "height": 1777
      },
      "title": "Apartment",
      "description": "Enjoy this stylish living area, complete with a comfortable green sofa and armchair, and a peek into the serene bedroom.",
      "link": "",
      "alt_text": "Living room with green sofa, armchair, and view into a bedroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2b31091d-01d0-4c04-be7f-5ef0d6950b35",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019e8976-1871-7745-a545-a5739f49748d.webp",
      "image_media": {
        "alt_text": "Modern bathroom with double vanity, granite countertops, and view of bedroom.",
        "public_id": "019e8976-1871-7745-a545-a5739f49748d",
        "storage_key": "property/5651440852795392/019e8976-1871-7745-a545-a5739f49748d.webp",
        "width": 2687,
        "height": 1792
      },
      "title": "Apartment",
      "description": "Experience luxury in this beautifully appointed bathroom, featuring a spacious double vanity with granite countertops and ample storage. The adjoining bedroom offers a serene retreat.",
      "link": "",
      "alt_text": "Modern bathroom with double vanity, granite countertops, and view of bedroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_72781c68-c9aa-4803-8259-241a6fbdf053",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019e8976-18a5-77a9-9779-a11312542075.webp",
      "image_media": {
        "alt_text": "Dog park area with artificial turf, benches and shade structures next to an apartment building.",
        "public_id": "019e8976-18a5-77a9-9779-a11312542075",
        "storage_key": "property/5651440852795392/019e8976-18a5-77a9-9779-a11312542075.webp",
        "width": 2530,
        "height": 1687
      },
      "title": "Community",
      "description": "Enjoy our spacious dog park, perfect for your furry friends to play and socialize. Featuring artificial turf, comfortable seating, and shaded areas.",
      "link": "",
      "alt_text": "Dog park area with artificial turf, benches and shade structures next to an apartment building.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c3f55e04-3548-4a84-8a0e-a1c1a983e175",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019e8976-1843-7108-bcc0-70523d9dc061.webp",
      "image_media": {
        "alt_text": "Modern apartment gym with treadmills, weight machines, and free weights.",
        "public_id": "019e8976-1843-7108-bcc0-70523d9dc061",
        "storage_key": "property/5651440852795392/019e8976-1843-7108-bcc0-70523d9dc061.webp",
        "width": 1679,
        "height": 1120
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring cardio machines, strength training equipment, and free weights for a complete workout experience.",
      "link": "",
      "alt_text": "Modern apartment gym with treadmills, weight machines, and free weights.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_619185d0-8976-404c-823e-d09e24f85d43",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019e8976-1a87-731a-8b19-239d4f1851e6.webp",
      "image_media": {
        "alt_text": "Exterior view of the apartment building with a red golf cart and blue SUV.",
        "public_id": "019e8976-1a87-731a-8b19-239d4f1851e6",
        "storage_key": "property/5651440852795392/019e8976-1a87-731a-8b19-239d4f1851e6.webp",
        "width": 1680,
        "height": 1120
      },
      "title": "Community",
      "description": "Beautifully designed apartment building exterior with a leasing center entrance, surrounded by manicured landscaping and parking.",
      "link": "",
      "alt_text": "Exterior view of the apartment building with a red golf cart and blue SUV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5a831db6-e260-468f-99c2-809887433f3d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019e8976-1829-70fb-bb86-fdfaa6ee3425.webp",
      "image_media": {
        "alt_text": "Kitchen island with granite countertops, stainless steel refrigerator, and washer/dryer.",
        "public_id": "019e8976-1829-70fb-bb86-fdfaa6ee3425",
        "storage_key": "property/5651440852795392/019e8976-1829-70fb-bb86-fdfaa6ee3425.webp",
        "width": 1659,
        "height": 1106
      },
      "title": "Apartment",
      "description": "Modern kitchen and laundry area featuring a granite-topped island, stainless steel appliances, and convenient in-unit washer and dryer.",
      "link": "",
      "alt_text": "Kitchen island with granite countertops, stainless steel refrigerator, and washer/dryer.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_cb4e32dd-58ff-45dd-8840-2f7b9199ae6b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019e8976-16c2-737d-ad92-e51123c56fe5.webp",
      "image_media": {
        "alt_text": "Modern bathroom with white subway tile tub surround, granite vanity, and wood-look flooring.",
        "public_id": "019e8976-16c2-737d-ad92-e51123c56fe5",
        "storage_key": "property/5651440852795392/019e8976-16c2-737d-ad92-e51123c56fe5.webp",
        "width": 1680,
        "height": 1120
      },
      "title": "Apartment",
      "description": "Step into luxury with this beautifully appointed bathroom, featuring a deep soaking tub, elegant granite countertops, and ample storage.",
      "link": "",
      "alt_text": "Modern bathroom with white subway tile tub surround, granite vanity, and wood-look flooring.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4c5f8409-5210-45f0-9f5b-a6eaa7a1a022",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019e8976-1641-74b9-afb5-8e4e45e0358b.webp",
      "image_media": {
        "alt_text": "Billiard table with balls racked in a lounge area with seating and TVs.",
        "public_id": "019e8976-1641-74b9-afb5-8e4e45e0358b",
        "storage_key": "property/5651440852795392/019e8976-1641-74b9-afb5-8e4e45e0358b.webp",
        "width": 1678,
        "height": 1120
      },
      "title": "Community",
      "description": "Enjoy a game of billiards in the resident lounge, complete with comfortable seating and entertainment options.",
      "link": "",
      "alt_text": "Billiard table with balls racked in a lounge area with seating and TVs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1a2a2d33-2e31-4216-bc99-b347e011cdc7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019e8976-069c-707f-994f-ebc0547a81b8.webp",
      "image_media": {
        "alt_text": "Primary bedroom with a king-size bed and plush bedding.",
        "public_id": "019e8976-069c-707f-994f-ebc0547a81b8",
        "storage_key": "property/5651440852795392/019e8976-069c-707f-994f-ebc0547a81b8.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Apartment",
      "description": "Luxurious primary bedroom featuring a comfortable king-size bed, soft carpeting, and modern decor. Enjoy a tranquil retreat after a long day.",
      "link": "",
      "alt_text": "Primary bedroom with a king-size bed and plush bedding.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_31975e1e-b1e8-45f5-b72d-9dd8a84d681d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019e8976-030c-750a-927c-4ea35bbc5bc5.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and a poolside building.",
        "public_id": "019e8976-030c-750a-927c-4ea35bbc5bc5",
        "storage_key": "property/5651440852795392/019e8976-030c-750a-927c-4ea35bbc5bc5.webp",
        "width": 1680,
        "height": 1120
      },
      "title": "Community",
      "description": "Relax by the sparkling resort-style swimming pool, complete with comfortable lounge chairs and a modern poolside cabana.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and a poolside building.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4ccc2d60-22ad-42b3-bb95-9ef3697f2b3a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019e8975-ed7b-75ca-b538-dbbabbfbfa6b.webp",
      "image_media": {
        "alt_text": "Modern kitchen with granite countertops, stainless steel appliances, and a view into the bedroom.",
        "public_id": "019e8975-ed7b-75ca-b538-dbbabbfbfa6b",
        "storage_key": "property/5651440852795392/019e8975-ed7b-75ca-b538-dbbabbfbfa6b.webp",
        "width": 1997,
        "height": 1332
      },
      "title": "Apartment",
      "description": "Experience luxury living in this stunning apartment kitchen, featuring sleek cabinetry, granite countertops, and modern stainless steel appliances. Enjoy the convenience of a spacious layout and an open view into the adjacent bedroom.",
      "link": "",
      "alt_text": "Modern kitchen with granite countertops, stainless steel appliances, and a view into the bedroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_3512b5a8-7923-424c-8697-d966a4d42987",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019e8975-edda-736a-b099-c3e389939d30.webp",
      "image_media": {
        "alt_text": "Modern apartment building exterior with landscaping and monument sign.",
        "public_id": "019e8975-edda-736a-b099-c3e389939d30",
        "storage_key": "property/5651440852795392/019e8975-edda-736a-b099-c3e389939d30.webp",
        "width": 2016,
        "height": 1344
      },
      "title": "Community",
      "description": "Welcome to Metro Station Premier Apartments, featuring a modern exterior design with beautiful landscaping and prominent signage.",
      "link": "",
      "alt_text": "Modern apartment building exterior with landscaping and monument sign.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d8bfc662-bf52-40fe-8ec5-5ad2b915fc1a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019e8975-e095-75b2-a1ee-4998bd459e48.webp",
      "image_media": {
        "alt_text": "Aerial view of an outdoor swimming pool with lounge chairs and umbrellas.",
        "public_id": "019e8975-e095-75b2-a1ee-4998bd459e48",
        "storage_key": "property/5651440852795392/019e8975-e095-75b2-a1ee-4998bd459e48.webp",
        "width": 2732,
        "height": 1820
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, surrounded by comfortable lounge chairs and vibrant orange umbrellas. Perfect for relaxing and soaking up the sun.",
      "link": "",
      "alt_text": "Aerial view of an outdoor swimming pool with lounge chairs and umbrellas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0eedb8c1-2dca-411d-bd9f-a0f5dbba2e7a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019e8975-dec3-77cb-b955-2ff74f1f0b23.webp",
      "image_media": {
        "alt_text": "Modern living room with a green sofa, armchair, and open-plan kitchen.",
        "public_id": "019e8975-dec3-77cb-b955-2ff74f1f0b23",
        "storage_key": "property/5651440852795392/019e8975-dec3-77cb-b955-2ff74f1f0b23.webp",
        "width": 2645,
        "height": 1764
      },
      "title": "Apartment",
      "description": "Stylish living room featuring a vibrant green sofa, comfortable armchair, and an open-plan kitchen with modern appliances and cabinetry. Perfect for entertaining or relaxing.",
      "link": "",
      "alt_text": "Modern living room with a green sofa, armchair, and open-plan kitchen.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_bd528b66-d64d-4e81-9b48-0d8287dafbe7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019e8975-e0a2-7067-ba40-9d43f8e6b0d6.webp",
      "image_media": {
        "alt_text": "View into a bathroom and closet from a hallway.",
        "public_id": "019e8975-e0a2-7067-ba40-9d43f8e6b0d6",
        "storage_key": "property/5651440852795392/019e8975-e0a2-7067-ba40-9d43f8e6b0d6.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "View into a bathroom with a toilet and bathtub, and a closet with a suitcase and storage shelf, from a hallway.",
      "link": "",
      "alt_text": "View into a bathroom and closet from a hallway.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_482b3792-e1e3-4e9d-889b-6d43cd291428",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019e8975-ea53-700f-8974-cb9a9b5fa7cd.webp",
      "image_media": {
        "alt_text": "Community lounge with island seating, coffee station, and television.",
        "public_id": "019e8975-ea53-700f-8974-cb9a9b5fa7cd",
        "storage_key": "property/5651440852795392/019e8975-ea53-700f-8974-cb9a9b5fa7cd.webp",
        "width": 1988,
        "height": 1326
      },
      "title": "Community",
      "description": "Gather in the modern community lounge, featuring a spacious island with bar seating, a convenient coffee and beverage station, and a large television for entertainment.",
      "link": "",
      "alt_text": "Community lounge with island seating, coffee station, and television.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9ec69412-5699-431d-bed6-2be13b300724",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019e8975-f139-7577-aeec-07248bcbb3fc.webp",
      "image_media": {
        "alt_text": "Modern kitchen with island, stainless steel appliances, and open living area.",
        "public_id": "019e8975-f139-7577-aeec-07248bcbb3fc",
        "storage_key": "property/5651440852795392/019e8975-f139-7577-aeec-07248bcbb3fc.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Apartment",
      "description": "Spacious and modern apartment kitchen featuring a large island, stainless steel appliances, and ample cabinet space, seamlessly opening to the living area.",
      "link": "",
      "alt_text": "Modern kitchen with island, stainless steel appliances, and open living area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e83d5a51-ca8b-4dca-be71-9062ec1857a2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019e8975-d924-7445-848a-35f4981d29e7.webp",
      "image_media": {
        "alt_text": "Modern coworking space with comfortable seating, a large communal table, and a workstation with computers.",
        "public_id": "019e8975-d924-7445-848a-35f4981d29e7",
        "storage_key": "property/5651440852795392/019e8975-d924-7445-848a-35f4981d29e7.webp",
        "width": 2662,
        "height": 1774
      },
      "title": "Community",
      "description": "A stylish and functional coworking space designed for productivity and collaboration, featuring plush seating, a spacious communal table, and convenient workstations.",
      "link": "",
      "alt_text": "Modern coworking space with comfortable seating, a large communal table, and a workstation with computers.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4d10637c-c186-4513-916b-32e8e6e90df9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019e8975-edf6-77aa-963d-1ae0b6042a13.webp",
      "image_media": {
        "alt_text": "Gym with punching bag, dumbbells, kettlebells, medicine balls, and TRX suspension trainers.",
        "public_id": "019e8975-edf6-77aa-963d-1ae0b6042a13",
        "storage_key": "property/5651440852795392/019e8975-edf6-77aa-963d-1ae0b6042a13.webp",
        "width": 2016,
        "height": 1344
      },
      "title": "Community",
      "description": "State-of-the-art fitness center featuring a variety of weights, cardio equipment, and training accessories for a complete workout.",
      "link": "",
      "alt_text": "Gym with punching bag, dumbbells, kettlebells, medicine balls, and TRX suspension trainers.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1d25f5d9-fbcc-469b-97e0-e15bfb358a49",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019e8975-ecdc-72df-9b11-3d6a565b6bde.webp",
      "image_media": {
        "alt_text": "Modern bedroom with a large bed, nightstands, and a window.",
        "public_id": "019e8975-ecdc-72df-9b11-3d6a565b6bde",
        "storage_key": "property/5651440852795392/019e8975-ecdc-72df-9b11-3d6a565b6bde.webp",
        "width": 1680,
        "height": 1120
      },
      "title": "Apartment",
      "description": "Relax in comfort in this beautifully appointed bedroom, featuring a plush bed and ample natural light.",
      "link": "",
      "alt_text": "Modern bedroom with a large bed, nightstands, and a window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8529edba-f084-4fe4-abfa-b29d829aa695",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019e8975-ced1-716f-8e79-dac436a3ecae.webp",
      "image_media": {
        "alt_text": "Walk-in closet with a white robe, towels, and stacked pillows on shelves.",
        "public_id": "019e8975-ced1-716f-8e79-dac436a3ecae",
        "storage_key": "property/5651440852795392/019e8975-ced1-716f-8e79-dac436a3ecae.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious walk-in closet featuring a plush robe, neatly folded towels, and decorative pillows, offering ample storage with custom shelving.",
      "link": "",
      "alt_text": "Walk-in closet with a white robe, towels, and stacked pillows on shelves.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4ce684eb-901b-4802-8f6e-92e571f5ccb2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019e8975-cf7e-74fd-90e2-808fd3b197ec.webp",
      "image_media": {
        "alt_text": "Coffee station with snacks and a Keurig machine, seating area with a round table and chairs.",
        "public_id": "019e8975-cf7e-74fd-90e2-808fd3b197ec",
        "storage_key": "property/5651440852795392/019e8975-cf7e-74fd-90e2-808fd3b197ec.webp",
        "width": 2352,
        "height": 1568
      },
      "title": "Community",
      "description": "Enjoy complimentary coffee, tea, and snacks at our resident coffee bar. A perfect spot to relax or catch up with neighbors.",
      "link": "",
      "alt_text": "Coffee station with snacks and a Keurig machine, seating area with a round table and chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_39475c69-c612-4829-bd5d-fc56d4b2040f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019e8975-cdc1-75ef-96c3-a6f47d42a2c5.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a vanity, sink, toilet, and shower.",
        "public_id": "019e8975-cdc1-75ef-96c3-a6f47d42a2c5",
        "storage_key": "property/5651440852795392/019e8975-cdc1-75ef-96c3-a6f47d42a2c5.webp",
        "width": 2686,
        "height": 1789
      },
      "title": "Apartment",
      "description": "Freshen up in style in this modern apartment bathroom, featuring a spacious vanity, elegant countertops, and a separate shower for ultimate comfort.",
      "link": "",
      "alt_text": "Modern bathroom with a vanity, sink, toilet, and shower.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_242d3f23-5215-4019-8036-4d0775129265",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019e8975-cdac-74b8-92bf-343e0c676837.webp",
      "image_media": {
        "alt_text": "Modern outdoor seating area with a fire pit and swimming pool in the background.",
        "public_id": "019e8975-cdac-74b8-92bf-343e0c676837",
        "storage_key": "property/5651440852795392/019e8975-cdac-74b8-92bf-343e0c676837.webp",
        "width": 2016,
        "height": 1344
      },
      "title": "Community",
      "description": "Enjoy the resort-style amenities including a sparkling swimming pool and a relaxing fire pit seating area.",
      "link": "",
      "alt_text": "Modern outdoor seating area with a fire pit and swimming pool in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_bc85b5c4-8022-403c-a3d1-fdcb7cff53d4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019e8975-cf3a-76d9-8244-e3dea994d987.webp",
      "image_media": {
        "alt_text": "Outdoor seating area with a tall table and stools, a built-in grill, and a brick wall in front of an apartment building.",
        "public_id": "019e8975-cf3a-76d9-8244-e3dea994d987",
        "storage_key": "property/5651440852795392/019e8975-cf3a-76d9-8244-e3dea994d987.webp",
        "width": 2016,
        "height": 1344
      },
      "title": "Community",
      "description": "Enjoy outdoor dining and entertaining with our modern grilling station and comfortable seating area, perfect for relaxing evenings.",
      "link": "",
      "alt_text": "Outdoor seating area with a tall table and stools, a built-in grill, and a brick wall in front of an apartment building.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_3167c42a-592c-4c07-a23d-eacd1a7e207f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019e8975-cefa-7421-a348-94921c2d9d4d.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, granite countertops, and a wine rack.",
        "public_id": "019e8975-cefa-7421-a348-94921c2d9d4d",
        "storage_key": "property/5651440852795392/019e8975-cefa-7421-a348-94921c2d9d4d.webp",
        "width": 2352,
        "height": 1568
      },
      "title": "Apartment",
      "description": "Beautifully designed kitchen featuring ample cabinet space, a large island with bar stools, and a full suite of stainless steel appliances. Perfect for entertaining and everyday living.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, granite countertops, and a wine rack.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "ec_08f51d4795ac8f96643e89c8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "source": "generator",
      "poi_name": "Sabor Latin Street Grill",
      "poi_type": "Restaurants",
      "poi_address": "9325 JW Clay Blvd, Charlotte, NC 28262, USA",
      "poi_short_description": "Tacos, quesadillas, and other Latin street food served in a counter-serve environment with daily specials.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1517-48a7-7512-af0a-1cbf434dd0cb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1517-48a7-7512-af0a-1cbf434dd0cb",
        "storage_key": "property/5651440852795392/019f1517-48a7-7512-af0a-1cbf434dd0cb.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.saborlatingrill.com/?utm_source=google&utm_medium=organic&utm_campaign=gbp-website-university",
      "poi_directions_map_url": "https://maps.google.com/?cid=12606994444976766843&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sabor-latin-street-grill",
      "poi_latitude": "35.3107152",
      "poi_longitude": "-80.7460624",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 980-819-7274",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1514-7a5c-73b9-b26f-015da1ef75f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1514-7a5c-73b9-b26f-015da1ef75f1",
        "storage_key": "property/5651440852795392/019f1514-7a5c-73b9-b26f-015da1ef75f1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJS2eKxFIdVIgRe78pKqcK9a4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "latin_american_restaurant"
    },
    {
      "id": "ec_7e1f347fb4c4a253de7ac615",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "source": "generator",
      "poi_name": "Boardwalk Billy's Raw Bar and Ribs",
      "poi_type": "Restaurants",
      "poi_address": "9005 J M Keynes Dr #2, Charlotte, NC 28262, USA",
      "poi_short_description": "Festive, easygoing hangout featuring BBQ, seafood & drinks plus a covered patio & a lively bar.",
      "poi_long_description": "Festive, easygoing hangout featuring BBQ, seafood & drinks plus a covered patio & a lively bar.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1514-3fc2-770b-aee4-cd800ccf1538.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1514-3fc2-770b-aee4-cd800ccf1538",
        "storage_key": "property/5651440852795392/019f1514-3fc2-770b-aee4-cd800ccf1538.webp",
        "width": 1280,
        "height": 573
      },
      "poi_business_url": "https://university.boardwalkbillys.com/#",
      "poi_directions_map_url": "https://maps.google.com/?cid=9333202762111351091&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "boardwalk-billys-raw-bar-and-ribs",
      "poi_latitude": "35.3106616",
      "poi_longitude": "-80.7495888",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 704-503-7427",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1514-7a5c-73b9-b26f-015da1ef75f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1514-7a5c-73b9-b26f-015da1ef75f1",
        "storage_key": "property/5651440852795392/019f1514-7a5c-73b9-b26f-015da1ef75f1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_7a5WzscVIgRM3lXdHYyhoE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "ec_91dd9b00ed7091f5e427dce2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "source": "generator",
      "poi_name": "The Wine Vault",
      "poi_type": "Restaurants",
      "poi_address": "9009 J M Keynes Dr #1, Charlotte, NC 28262, USA",
      "poi_short_description": "Cozy, friendly venue offering wine and beer by the glass, plus bottled selections.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1517-45cd-7003-af61-05e9f273eda1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1517-45cd-7003-af61-05e9f273eda1",
        "storage_key": "property/5651440852795392/019f1517-45cd-7003-af61-05e9f273eda1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=11623937510044892290&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-wine-vault",
      "poi_latitude": "35.310627",
      "poi_longitude": "-80.749285",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 704-548-9463",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1517-9ff3-708b-a422-1f79dd715030.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1517-9ff3-708b-a422-1f79dd715030",
        "storage_key": "property/5651440852795392/019f1517-9ff3-708b-a422-1f79dd715030.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJd1TCWDscVIgRgnyQQZSFUKE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "wine_bar"
    },
    {
      "id": "ec_279ec1498aa85873112b63c9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "source": "generator",
      "poi_name": "Famous Toastery",
      "poi_type": "Restaurants",
      "poi_address": "8933 J M Keynes Dr #2, Charlotte, NC 28262, USA",
      "poi_short_description": "Comfortable setting for classic & creative takes on American breakfast, brunch & lunch dishes.",
      "poi_long_description": "Comfortable setting for classic & creative takes on American breakfast, brunch & lunch dishes.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1517-47cb-752f-9abd-cd448a81a548.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1517-47cb-752f-9abd-cd448a81a548",
        "storage_key": "property/5651440852795392/019f1517-47cb-752f-9abd-cd448a81a548.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.famoustoastery.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=615834463933113794&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "famous-toastery",
      "poi_latitude": "35.3103407",
      "poi_longitude": "-80.7494772",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 704-503-9599",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1514-7a5c-73b9-b26f-015da1ef75f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1514-7a5c-73b9-b26f-015da1ef75f1",
        "storage_key": "property/5651440852795392/019f1514-7a5c-73b9-b26f-015da1ef75f1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJB74QVzscVIgRwiUtny7iiwg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "breakfast_restaurant"
    },
    {
      "id": "ec_9f4428f4d717de0982e73d41",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "source": "generator",
      "poi_name": "Crafty Crab",
      "poi_type": "Restaurants",
      "poi_address": "8933 J M Keynes Dr #1, Charlotte, NC 28262, USA",
      "poi_short_description": "Seafood chain specializing in crab boils and other Southern-inspired dishes.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1517-445d-76d8-aade-3e23b3117c56.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1517-445d-76d8-aade-3e23b3117c56",
        "storage_key": "property/5651440852795392/019f1517-445d-76d8-aade-3e23b3117c56.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "http://craftycrabrestaurant.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9336963873516018917&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "crafty-crab",
      "poi_latitude": "35.3103305",
      "poi_longitude": "-80.749203",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 980-999-5111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1514-7a5c-73b9-b26f-015da1ef75f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1514-7a5c-73b9-b26f-015da1ef75f1",
        "storage_key": "property/5651440852795392/019f1514-7a5c-73b9-b26f-015da1ef75f1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJfTs7l7kdVIgR5dyTcSyPk4E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "ec_b5b0f7dd8204748cb525dbcc",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "source": "generator",
      "poi_name": "Zapata's Mexican Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "8927 J M Keynes Dr, Charlotte, NC 28262, USA",
      "poi_short_description": "Family-family outpost serving generous portions of familiar Mexican plates in relaxed surrounds.",
      "poi_long_description": "Family-family outpost serving generous portions of familiar Mexican plates in relaxed surrounds.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1517-4418-722d-8dfc-6c68bb8fafc0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1517-4418-722d-8dfc-6c68bb8fafc0",
        "storage_key": "property/5651440852795392/019f1517-4418-722d-8dfc-6c68bb8fafc0.webp",
        "width": 1280,
        "height": 590
      },
      "poi_business_url": "https://zapatasuniversity.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9505794243155199311&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "zapatas-mexican-restaurant",
      "poi_latitude": "35.3090293",
      "poi_longitude": "-80.7492867",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 704-503-1979",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1514-7a5c-73b9-b26f-015da1ef75f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1514-7a5c-73b9-b26f-015da1ef75f1",
        "storage_key": "property/5651440852795392/019f1514-7a5c-73b9-b26f-015da1ef75f1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJucmkqSQcVIgRTwU4E4Bd64M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "ec_db6eb2cbde3408530422976e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "source": "generator",
      "poi_name": "Piada Italian Street Food",
      "poi_type": "Restaurants",
      "poi_address": "8932 J M Keynes Dr #120, Charlotte, NC 28262, USA",
      "poi_short_description": "Counter-order restaurant serving design-your-own Italian food including wraps, pastas & salads.",
      "poi_long_description": "Counter-order restaurant serving design-your-own Italian food including wraps, pastas & salads.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1517-4c78-7198-8260-51de81d36711.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1517-4c78-7198-8260-51de81d36711",
        "storage_key": "property/5651440852795392/019f1517-4c78-7198-8260-51de81d36711.webp",
        "width": 1280,
        "height": 830
      },
      "poi_business_url": "https://mypiada.com/locations/university-place",
      "poi_directions_map_url": "https://maps.google.com/?cid=11497166655809148898&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "piada-italian-street-food",
      "poi_latitude": "35.309612",
      "poi_longitude": "-80.7479",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 704-885-1456",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1514-7a5c-73b9-b26f-015da1ef75f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1514-7a5c-73b9-b26f-015da1ef75f1",
        "storage_key": "property/5651440852795392/019f1514-7a5c-73b9-b26f-015da1ef75f1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJqcULXMkdVIgR4lf4qigkjp8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "ec_cfc08596b70a3780ad16727a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "source": "generator",
      "poi_name": "Noodles and Company",
      "poi_type": "Restaurants",
      "poi_address": "8926 J M Keynes Dr, Charlotte, NC 28262, USA",
      "poi_short_description": "Counter-serve chain offering international noodle & pasta dishes from mac 'n' cheese to Pad Thai.",
      "poi_long_description": "Counter-serve chain offering international noodle & pasta dishes from mac 'n' cheese to Pad Thai.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1517-47e1-713e-a23c-88fbf867caf7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1517-47e1-713e-a23c-88fbf867caf7",
        "storage_key": "property/5651440852795392/019f1517-47e1-713e-a23c-88fbf867caf7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.noodles.com/nc/charlotte/8926-jm-keynes-dr?utm_campaign=soci&utm_medium=organic&utm_source=google",
      "poi_directions_map_url": "https://maps.google.com/?cid=10370424908202622193&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "noodles-and-company",
      "poi_latitude": "35.3090197",
      "poi_longitude": "-80.7477978",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 704-549-0188",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1514-7a5c-73b9-b26f-015da1ef75f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1514-7a5c-73b9-b26f-015da1ef75f1",
        "storage_key": "property/5651440852795392/019f1514-7a5c-73b9-b26f-015da1ef75f1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJL0seSCMcVIgR8bxHV4Im648",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_e6d3242a86af1b6ded05b890",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "source": "generator",
      "poi_name": "Blaze Pizza",
      "poi_type": "Restaurants",
      "poi_address": "8948 J M Keynes Dr #400, Charlotte, NC 28262, USA",
      "poi_short_description": "Hip counter-serve pizzeria dishing up crispy, thin-crust pies made with creative toppings & sauces.",
      "poi_long_description": "Hip counter-serve pizzeria dishing up crispy, thin-crust pies made with creative toppings & sauces.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1517-4903-70ff-8c3c-63038c037a6a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1517-4903-70ff-8c3c-63038c037a6a",
        "storage_key": "property/5651440852795392/019f1517-4903-70ff-8c3c-63038c037a6a.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.blazepizza.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17455837503924574762&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "blaze-pizza",
      "poi_latitude": "35.3105691",
      "poi_longitude": "-80.7469788",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 980-217-4306",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1514-7a5c-73b9-b26f-015da1ef75f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1514-7a5c-73b9-b26f-015da1ef75f1",
        "storage_key": "property/5651440852795392/019f1514-7a5c-73b9-b26f-015da1ef75f1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJnZsy2jwcVIgRKppdjrmXP_I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "ec_bb7810c130501e9caef4bd10",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "source": "generator",
      "poi_name": "Frendz Pizza",
      "poi_type": "Restaurants",
      "poi_address": "6925 University City Blvd, Charlotte, NC 28262, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1517-44c9-73b2-811a-bd3865c54d9e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1517-44c9-73b2-811a-bd3865c54d9e",
        "storage_key": "property/5651440852795392/019f1517-44c9-73b2-811a-bd3865c54d9e.webp",
        "width": 1167,
        "height": 1167
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=5588283438189500154&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "frendz-pizza",
      "poi_latitude": "35.2904758",
      "poi_longitude": "-80.7654136",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 704-509-0009",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1514-7a5c-73b9-b26f-015da1ef75f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1514-7a5c-73b9-b26f-015da1ef75f1",
        "storage_key": "property/5651440852795392/019f1514-7a5c-73b9-b26f-015da1ef75f1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3XDf4owfVIgR-tZ71S2SjU0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "ec_caee5d8a42e03f120bb1a658",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "source": "generator",
      "poi_name": "Chipotle Mexican Grill",
      "poi_type": "Restaurants",
      "poi_address": "6925 University City Blvd, Charlotte, NC 28262, USA",
      "poi_short_description": "Casual restaurant offering Mexican fare, including design-your-own burritos, tacos & bowls.",
      "poi_long_description": "Casual restaurant offering Mexican fare, including design-your-own burritos, tacos & bowls.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1517-4cfb-75a6-a653-ab4d425f6e30.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1517-4cfb-75a6-a653-ab4d425f6e30",
        "storage_key": "property/5651440852795392/019f1517-4cfb-75a6-a653-ab4d425f6e30.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.chipotle.com/nc/charlotte/6925-university-city-blvd?utm_source=google&utm_medium=yext&utm_campaign=yext_listings?restaurant=3125",
      "poi_directions_map_url": "https://maps.google.com/?cid=510962079302961025&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chipotle-mexican-grill",
      "poi_latitude": "35.2905807",
      "poi_longitude": "-80.7660271",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 704-596-5475",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1514-7a5c-73b9-b26f-015da1ef75f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1514-7a5c-73b9-b26f-015da1ef75f1",
        "storage_key": "property/5651440852795392/019f1514-7a5c-73b9-b26f-015da1ef75f1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJOTWLYH0eVIgRgUeMzk1NFwc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "ec_3e65aa24fa7e83aed7ce85e6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "source": "generator",
      "poi_name": "Culver’s",
      "poi_type": "Restaurants",
      "poi_address": "7031 University City Blvd, Charlotte, NC 28262, USA",
      "poi_short_description": "Fast-food chain specializing in frozen custard & signature burgers made with Midwest beef & dairy.",
      "poi_long_description": "Fast-food chain specializing in frozen custard & signature burgers made with Midwest beef & dairy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1517-520d-716b-875b-08770f6554fa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1517-520d-716b-875b-08770f6554fa",
        "storage_key": "property/5651440852795392/019f1517-520d-716b-875b-08770f6554fa.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.culvers.com/restaurants/charlotte-nc-university-city-blvd/?utm_source=Google&utm_medium=Maps&utm_campaign=Google+Places",
      "poi_directions_map_url": "https://maps.google.com/?cid=4588600767079458742&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "culvers",
      "poi_latitude": "35.2905794",
      "poi_longitude": "-80.7646982",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 980-348-7611",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1514-7a5c-73b9-b26f-015da1ef75f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1514-7a5c-73b9-b26f-015da1ef75f1",
        "storage_key": "property/5651440852795392/019f1514-7a5c-73b9-b26f-015da1ef75f1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJUc9s64ceVIgRtifbERb8rT8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "ec_33b59f84b554dacd6563ed69",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "source": "generator",
      "poi_name": "Ishi",
      "poi_type": "Restaurants",
      "poi_address": "8205 University City Blvd #8129, Charlotte, NC 28213, USA",
      "poi_short_description": "Stalwart restaurant offering a variety of sushi rolls & Japanese hibachi meals in a relaxed setting.",
      "poi_long_description": "Stalwart restaurant offering a variety of sushi rolls & Japanese hibachi meals in a relaxed setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1517-520e-750f-91e5-e8045aa947f6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1517-520e-750f-91e5-e8045aa947f6",
        "storage_key": "property/5651440852795392/019f1517-520e-750f-91e5-e8045aa947f6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://sushiishi.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5691385082080949325&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ishi",
      "poi_latitude": "35.294927",
      "poi_longitude": "-80.7474965",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 704-921-9219",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1514-7a5c-73b9-b26f-015da1ef75f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1514-7a5c-73b9-b26f-015da1ef75f1",
        "storage_key": "property/5651440852795392/019f1514-7a5c-73b9-b26f-015da1ef75f1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJPwphFlgqw4ARTXRk8ZPc-04",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "japanese_restaurant"
    },
    {
      "id": "ec_b98be4e5f1458e367689a29f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "source": "generator",
      "poi_name": "Qamaria Yemeni Coffee Co.",
      "poi_type": "Restaurants",
      "poi_address": "9325 JW Clay Blvd Ste 223, Charlotte, NC 28262, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1517-513b-77ee-9411-2e48c97efe88.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1517-513b-77ee-9411-2e48c97efe88",
        "storage_key": "property/5651440852795392/019f1517-513b-77ee-9411-2e48c97efe88.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://qamariacoffee.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3148924412245079813&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "qamaria-yemeni-coffee-co",
      "poi_latitude": "35.3109455",
      "poi_longitude": "-80.7458656",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 980-430-1111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1517-9ff6-774e-9f9c-cd1162a1ff00.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1517-9ff6-774e-9f9c-cd1162a1ff00",
        "storage_key": "property/5651440852795392/019f1517-9ff6-774e-9f9c-cd1162a1ff00.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJ6e1KBAAdVIgRBXdsuBE6sys",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "ec_fb8f36611643eb0da6800bc7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "source": "generator",
      "poi_name": "Dave's Hot Chicken",
      "poi_type": "Restaurants",
      "poi_address": "8932 J M Keynes Dr #100, Charlotte, NC 28262, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1514-43e8-7027-a84f-a880355966c7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1514-43e8-7027-a84f-a880355966c7",
        "storage_key": "property/5651440852795392/019f1514-43e8-7027-a84f-a880355966c7.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://restaurants.daveshotchicken.com/nc/charlotte/spicy-chicken-sandwich-on-keynes-drive/?utm_campaign=google_maps&utm_medium=organic&utm_source=google&utm_content=website&utm_keyword=1127",
      "poi_directions_map_url": "https://maps.google.com/?cid=13512993024171001685&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "daves-hot-chicken",
      "poi_latitude": "35.3095762",
      "poi_longitude": "-80.7479429",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 980-392-2120",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1514-7a5c-73b9-b26f-015da1ef75f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1514-7a5c-73b9-b26f-015da1ef75f1",
        "storage_key": "property/5651440852795392/019f1514-7a5c-73b9-b26f-015da1ef75f1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJK-0dQDodVIgRVUcLgo_Lh7s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chicken_restaurant"
    },
    {
      "id": "ec_136466a6dd5eeffb0c1e70e9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "source": "generator",
      "poi_name": "El Tigre Mini Super",
      "poi_type": "Shopping & Retail",
      "poi_address": "Charlotte, NC 28213, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=6820621220586509504&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "el-tigre-mini-super",
      "poi_latitude": "35.2589762",
      "poi_longitude": "-80.7823402",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1514-7a3e-7595-933e-0923aed6f76f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1514-7a3e-7595-933e-0923aed6f76f",
        "storage_key": "property/5651440852795392/019f1514-7a3e-7595-933e-0923aed6f76f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJLzFioEweVIgRwNSM6Ny2p14",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "point_of_interest"
    },
    {
      "id": "ec_24f8c84a89e71cd5829460e4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "source": "generator",
      "poi_name": "New Century Oriental Food Supermarket",
      "poi_type": "Shopping & Retail",
      "poi_address": "4500 N Tryon St, Charlotte, NC 28213, USA",
      "poi_short_description": "Sprawling Asian market stocking everything from seafood and spices to rice and noodles.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1517-52bb-704f-9739-95f10a75df0e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1517-52bb-704f-9739-95f10a75df0e",
        "storage_key": "property/5651440852795392/019f1517-52bb-704f-9739-95f10a75df0e.webp",
        "width": 1280,
        "height": 577
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=17723978129106244630&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "new-century-oriental-food-supermarket",
      "poi_latitude": "35.2571846",
      "poi_longitude": "-80.79109919999999",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 704-921-1716",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1514-7a2c-720a-9cae-4756d55201e4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1514-7a2c-720a-9cae-4756d55201e4",
        "storage_key": "property/5651440852795392/019f1514-7a2c-720a-9cae-4756d55201e4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJYUEeNMsfVIgRFpQr6DM4-PU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_53c974886a9e49be2b7fd546",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "source": "generator",
      "poi_name": "Family Dollar",
      "poi_type": "Shopping & Retail",
      "poi_address": "Tryon Plz Shp Ctr, 4500 N Tryon St, Charlotte, NC 28213, USA",
      "poi_short_description": "Discount chain carrying a variety of goods, including groceries, household items & beauty products.",
      "poi_long_description": "Discount chain carrying a variety of goods, including groceries, household items & beauty products.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1517-55dd-77eb-a067-9d2395f649a3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1517-55dd-77eb-a067-9d2395f649a3",
        "storage_key": "property/5651440852795392/019f1517-55dd-77eb-a067-9d2395f649a3.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://locations.familydollar.com/nc/charlotte/4500-n-tryon-st?utm_source=google&utm_medium=organic&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=9590415075581075885&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "family-dollar",
      "poi_latitude": "35.2568053",
      "poi_longitude": "-80.7911467",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 980-221-1882",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1514-7a2f-7087-bb83-81f136a1eaa8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1514-7a2f-7087-bb83-81f136a1eaa8",
        "storage_key": "property/5651440852795392/019f1514-7a2f-7087-bb83-81f136a1eaa8.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJYUEeNMsfVIgRraGP9LL_F4U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "discount_store"
    },
    {
      "id": "ec_c3654ee27222e0cafb40574c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "source": "generator",
      "poi_name": "Compare Foods Supermarket",
      "poi_type": "Shopping & Retail",
      "poi_address": "4316 N Tryon St, Charlotte, NC 28213, USA",
      "poi_short_description": "Family-owned supermarket chain with major-brand general groceries & a variety of fresh goods.",
      "poi_long_description": "Family-owned supermarket chain with major-brand general groceries & a variety of fresh goods.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1517-56bb-77fd-a21c-2625a0f4f595.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1517-56bb-77fd-a21c-2625a0f4f595",
        "storage_key": "property/5651440852795392/019f1517-56bb-77fd-a21c-2625a0f4f595.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.compareclt.com/my-store/store-locator",
      "poi_directions_map_url": "https://maps.google.com/?cid=7853957087509697102&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "compare-foods-supermarket",
      "poi_latitude": "35.2576756",
      "poi_longitude": "-80.79351439999999",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 704-596-3495",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1514-7a2c-720a-9cae-4756d55201e4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1514-7a2c-720a-9cae-4756d55201e4",
        "storage_key": "property/5651440852795392/019f1514-7a2c-720a-9cae-4756d55201e4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJo7CUSxTOUIgRTlIt6lvc_mw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "ec_e90da5d8ecc5d6ac14825991",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "source": "generator",
      "poi_name": "Corona Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "6320 N Tryon St Ste G, Charlotte, NC 28213, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1517-57d4-73e9-b289-a20516914e5a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1517-57d4-73e9-b289-a20516914e5a",
        "storage_key": "property/5651440852795392/019f1517-57d4-73e9-b289-a20516914e5a.webp",
        "width": 598,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=14405978366891177344&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "corona-market",
      "poi_latitude": "35.2741629",
      "poi_longitude": "-80.7660774",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1514-7a2c-720a-9cae-4756d55201e4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1514-7a2c-720a-9cae-4756d55201e4",
        "storage_key": "property/5651440852795392/019f1514-7a2c-720a-9cae-4756d55201e4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJn6-AXV8eVIgRgLWCoP9Q7Mc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_e287a06365761350f5d91089",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "source": "generator",
      "poi_name": "Circle K",
      "poi_type": "Shopping & Retail",
      "poi_address": "7040 N Tryon St, Charlotte, NC 28262, USA",
      "poi_short_description": "Fuel and snack stop that also features a car wash, an ATM and friendly service.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1517-57d1-70d3-a3bb-e6f21d8afa2d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1517-57d1-70d3-a3bb-e6f21d8afa2d",
        "storage_key": "property/5651440852795392/019f1517-57d1-70d3-a3bb-e6f21d8afa2d.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.circlek.com/store-locator/US/charlotte/7040-n-tryon-st/2703150?utm_source=google&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=5131971796562290025&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "circle-k",
      "poi_latitude": "35.2838512",
      "poi_longitude": "-80.7623606",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 704-509-1414",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1517-a016-727b-8537-0ee1db4b6365.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1517-a016-727b-8537-0ee1db4b6365",
        "storage_key": "property/5651440852795392/019f1517-a016-727b-8537-0ee1db4b6365.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJUyUGdokeVIgRaSVrmyhtOEc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "ec_92f8cabf1ae30491bfcc0ec9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "source": "generator",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "8120 University City Blvd, Charlotte, NC 28213, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1517-5a8e-7716-a794-81e56f5da1e6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1517-5a8e-7716-a794-81e56f5da1e6",
        "storage_key": "property/5651440852795392/019f1517-5a8e-7716-a794-81e56f5da1e6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.target.com/sl/ne-charlotte/1081",
      "poi_directions_map_url": "https://maps.google.com/?cid=13592394189975419888&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "target",
      "poi_latitude": "35.2929967",
      "poi_longitude": "-80.74573989999999",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 704-599-6332",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1514-7a2f-7087-bb83-81f136a1eaa8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1514-7a2f-7087-bb83-81f136a1eaa8",
        "storage_key": "property/5651440852795392/019f1514-7a2f-7087-bb83-81f136a1eaa8.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ05zW0ZgeVIgR8HuRDIDiobw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "ec_731f0363a4e345310d703db6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "source": "generator",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Shopping & Retail",
      "poi_address": "8120 University City Blvd, Charlotte, NC 28213, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1517-5967-729d-a32f-ea449dd7b98e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1517-5967-729d-a32f-ea449dd7b98e",
        "storage_key": "property/5651440852795392/019f1517-5967-729d-a32f-ea449dd7b98e.webp",
        "width": 1000,
        "height": 667
      },
      "poi_business_url": "https://www.cvs.com/store-locator/charlotte-nc-pharmacies/8120-university-city-blvd-charlotte-nc-28213/storeid=16461?WT.mc_id=LS_GOOGLE_RX_16461",
      "poi_directions_map_url": "https://maps.google.com/?cid=3252503274417569303&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "35.2929967",
      "poi_longitude": "-80.74573989999999",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 704-599-3472",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1517-a00c-7184-b278-3692a9502249.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1517-a00c-7184-b278-3692a9502249",
        "storage_key": "property/5651440852795392/019f1517-a00c-7184-b278-3692a9502249.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ05zW0ZgeVIgRFz503n42Iy0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_a607ecd5fc2b6ee88f14e584",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "source": "generator",
      "poi_name": "Rite Aid Pharmacy",
      "poi_type": "Shopping & Retail",
      "poi_address": "8532 University City Blvd, Charlotte, NC 28213, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1517-5bd9-73a8-b13e-06d2a532742c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1517-5bd9-73a8-b13e-06d2a532742c",
        "storage_key": "property/5651440852795392/019f1517-5bd9-73a8-b13e-06d2a532742c.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.riteaid.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17128848780856964461&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rite-aid-pharmacy",
      "poi_latitude": "35.2956632",
      "poi_longitude": "-80.73930720000001",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 704-549-1593",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1517-a00c-7184-b278-3692a9502249.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1517-a00c-7184-b278-3692a9502249",
        "storage_key": "property/5651440852795392/019f1517-a00c-7184-b278-3692a9502249.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJBePK3aAeVIgRbbVcsjblte0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_0703b849d393fb70fc1fc23d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "source": "generator",
      "poi_name": "Walmart Neighborhood Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "11530 N Tryon St, Charlotte, NC 28262, USA",
      "poi_short_description": "Clean supermarket with everyday groceries and a variety of products at low prices.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1517-5b50-7593-8e44-b1f9e38e8d22.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1517-5b50-7593-8e44-b1f9e38e8d22",
        "storage_key": "property/5651440852795392/019f1517-5b50-7593-8e44-b1f9e38e8d22.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.walmart.com/store/6233-charlotte-nc/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=1734489702722648400&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-neighborhood-market",
      "poi_latitude": "35.3341357",
      "poi_longitude": "-80.7125191",
      "poi_miles_from_property": "12.4 mi",
      "poi_walking_minutes": "4 hours 33 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 980-428-8134",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1514-7a2c-720a-9cae-4756d55201e4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1514-7a2c-720a-9cae-4756d55201e4",
        "storage_key": "property/5651440852795392/019f1514-7a2c-720a-9cae-4756d55201e4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJkym2fIMbVIgRUDlb5TElEhg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_296737abe98e1f285cafe5ad",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "source": "generator",
      "poi_name": "University of North Carolina at Charlotte",
      "poi_type": "Education",
      "poi_address": "9201 University City Blvd, Charlotte, NC 28223, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1514-4858-76ec-9a25-e7d58a93f37f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1514-4858-76ec-9a25-e7d58a93f37f",
        "storage_key": "property/5651440852795392/019f1514-4858-76ec-9a25-e7d58a93f37f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.charlotte.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7728009800198595827&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-of-north-carolina-at-charlotte",
      "poi_latitude": "35.3074169",
      "poi_longitude": "-80.73521219999999",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 704-687-8622",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1514-7a5f-72e0-9de4-510c24564d63.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1514-7a5f-72e0-9de4-510c24564d63",
        "storage_key": "property/5651440852795392/019f1514-7a5f-72e0-9de4-510c24564d63.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJVyOp0BocVIgR8yST8fdnP2s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_661150f46b96a46e0f868c44",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "source": "generator",
      "poi_name": "Newell Elementary School",
      "poi_type": "Education",
      "poi_address": "325 Rocky River Rd W, Charlotte, NC 28213, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.cmsk12.org/newellES",
      "poi_directions_map_url": "https://maps.google.com/?cid=8833122033534217963&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "newell-elementary-school",
      "poi_latitude": "35.2867519",
      "poi_longitude": "-80.7535508",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 980-343-6820",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1514-7a5f-72e0-9de4-510c24564d63.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1514-7a5f-72e0-9de4-510c24564d63",
        "storage_key": "property/5651440852795392/019f1514-7a5f-72e0-9de4-510c24564d63.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ216MvroeVIgR6657irCNlXo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_26d19f2f47e8017a26553de1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "source": "generator",
      "poi_name": "Hidden Valley Elementary School",
      "poi_type": "Education",
      "poi_address": "5100 Snow White Ln, Charlotte, NC 28213, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1517-5c91-70b0-bf99-9299b60d4abe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1517-5c91-70b0-bf99-9299b60d4abe",
        "storage_key": "property/5651440852795392/019f1517-5c91-70b0-bf99-9299b60d4abe.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.cmsk12.org/hiddenvalleyES",
      "poi_directions_map_url": "https://maps.google.com/?cid=12063670551990290462&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hidden-valley-elementary-school",
      "poi_latitude": "35.268156",
      "poi_longitude": "-80.784279",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 980-343-6810",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1514-7a5f-72e0-9de4-510c24564d63.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1514-7a5f-72e0-9de4-510c24564d63",
        "storage_key": "property/5651440852795392/019f1514-7a5f-72e0-9de4-510c24564d63.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJVeB7mkgeVIgRHsi4cnPEaqc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_e3aecdec0b093eff8e7f4b25",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "source": "generator",
      "poi_name": "Martin Luther King, Jr. Middle",
      "poi_type": "Education",
      "poi_address": "500 Bilmark Ave, Charlotte, NC 28213, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1517-5efa-72d4-a937-f4c917081e07.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1517-5efa-72d4-a937-f4c917081e07",
        "storage_key": "property/5651440852795392/019f1517-5efa-72d4-a937-f4c917081e07.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.cmsk12.org/martinlutherkingjrMS",
      "poi_directions_map_url": "https://maps.google.com/?cid=5888650442415146741&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "martin-luther-king-jr-middle",
      "poi_latitude": "35.26339189999999",
      "poi_longitude": "-80.7786995",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 980-343-0698",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1514-7a5f-72e0-9de4-510c24564d63.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1514-7a5f-72e0-9de4-510c24564d63",
        "storage_key": "property/5651440852795392/019f1514-7a5f-72e0-9de4-510c24564d63.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJpU7tak4eVIgR9QaawmCwuFE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_eb8aced561391602c441ab10",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "source": "generator",
      "poi_name": "United Community Charter School",
      "poi_type": "Education",
      "poi_address": "1406 Suther Rd, Charlotte, NC 28213, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1517-5d57-74eb-a3d9-2936b819f9ce.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1517-5d57-74eb-a3d9-2936b819f9ce",
        "storage_key": "property/5651440852795392/019f1517-5d57-74eb-a3d9-2936b819f9ce.webp",
        "width": 1280,
        "height": 512
      },
      "poi_business_url": "http://www.ucsnc.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14828278799356661249&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "united-community-charter-school",
      "poi_latitude": "35.2989426",
      "poi_longitude": "-80.72920409999999",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 980-819-0555",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1514-7a5f-72e0-9de4-510c24564d63.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1514-7a5f-72e0-9de4-510c24564d63",
        "storage_key": "property/5651440852795392/019f1514-7a5f-72e0-9de4-510c24564d63.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJA4lu6EoZVIgRAQ4cIgGhyM0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_d96ca81734cac03aee80a6b4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "source": "generator",
      "poi_name": "UpROAR Leadership Academy",
      "poi_type": "Education",
      "poi_address": "1001 E W.T. Harris Blvd, Charlotte, NC 28213, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=6274725554385072084&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "uproar-leadership-academy",
      "poi_latitude": "35.2943269",
      "poi_longitude": "-80.73988829999999",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 980-299-0080",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1514-7a5f-72e0-9de4-510c24564d63.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1514-7a5f-72e0-9de4-510c24564d63",
        "storage_key": "property/5651440852795392/019f1514-7a5f-72e0-9de4-510c24564d63.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJTW5AtlMeVIgR1C8wlKVNFFc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_122edbb3f2426171eee44f2a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "source": "generator",
      "poi_name": "Cornerstone Adventist Academy",
      "poi_type": "Education",
      "poi_address": "11431 University City Blvd building b, Charlotte, NC 28213, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1517-5e71-74c6-a9eb-cfa5c8115b53.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1517-5e71-74c6-a9eb-cfa5c8115b53",
        "storage_key": "property/5651440852795392/019f1517-5e71-74c6-a9eb-cfa5c8115b53.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.cornerstoneadventistacademy.org/contact",
      "poi_directions_map_url": "https://maps.google.com/?cid=16709043290493836666&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cornerstone-adventist-academy",
      "poi_latitude": "35.3160412",
      "poi_longitude": "-80.69297850000001",
      "poi_miles_from_property": "15.4 mi",
      "poi_walking_minutes": "5 hours 41 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 704-549-8007",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1514-7a5f-72e0-9de4-510c24564d63.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1514-7a5f-72e0-9de4-510c24564d63",
        "storage_key": "property/5651440852795392/019f1514-7a5f-72e0-9de4-510c24564d63.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJxS62WscbVIgRel2CKlhy4uc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_686f1f81c786465a19b5d7d1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "source": "generator",
      "poi_name": "Nana's Place Learning Center",
      "poi_type": "Education",
      "poi_address": "1825 Back Creek Dr, Charlotte, NC 28213, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.nanasplaceinc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10345672992730134100&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nanas-place-learning-center",
      "poi_latitude": "35.2838515",
      "poi_longitude": "-80.7261424",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 704-597-3900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1514-7a5f-72e0-9de4-510c24564d63.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1514-7a5f-72e0-9de4-510c24564d63",
        "storage_key": "property/5651440852795392/019f1514-7a5f-72e0-9de4-510c24564d63.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJzRGkMbIeVIgRVDYI7sU2k48",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "ec_8e38189397b77b797cc0c6cb",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "source": "generator",
      "poi_name": "Childcare Network",
      "poi_type": "Education",
      "poi_address": "8216 University Ridge Dr, Charlotte, NC 28213, USA",
      "poi_short_description": "Kid-friendly spot offering childcare programs for kids from infancy through elementary school.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1517-620e-76dc-b72e-6b38dcfff9df.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1517-620e-76dc-b72e-6b38dcfff9df",
        "storage_key": "property/5651440852795392/019f1517-620e-76dc-b72e-6b38dcfff9df.webp",
        "width": 1024,
        "height": 576
      },
      "poi_business_url": "https://schools.childcarenetwork.com/nc/charlotte/8216-university-ridge-drive",
      "poi_directions_map_url": "https://maps.google.com/?cid=4915712994787730640&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "childcare-network",
      "poi_latitude": "35.2913764",
      "poi_longitude": "-80.737422",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 704-598-1911",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1514-7a5f-72e0-9de4-510c24564d63.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1514-7a5f-72e0-9de4-510c24564d63",
        "storage_key": "property/5651440852795392/019f1514-7a5f-72e0-9de4-510c24564d63.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJpQV0EqQeVIgR0CQYmOweOEQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "ec_978d0cb94191c5f9eeab5a55",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "source": "generator",
      "poi_name": "Julius L. Chambers High School",
      "poi_type": "Education",
      "poi_address": "7600 IBM Dr, Charlotte, NC 28262, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1517-5e6f-75e5-8485-cd1a9a43c9da.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1517-5e6f-75e5-8485-cd1a9a43c9da",
        "storage_key": "property/5651440852795392/019f1517-5e6f-75e5-8485-cd1a9a43c9da.webp",
        "width": 413,
        "height": 275
      },
      "poi_business_url": "https://www.cmsk12.org/chambersHS",
      "poi_directions_map_url": "https://maps.google.com/?cid=17524243692802135939&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "julius-l-chambers-high-school",
      "poi_latitude": "35.3008041",
      "poi_longitude": "-80.76758769999999",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 980-343-5284",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1514-7a5f-72e0-9de4-510c24564d63.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1514-7a5f-72e0-9de4-510c24564d63",
        "storage_key": "property/5651440852795392/019f1514-7a5f-72e0-9de4-510c24564d63.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJYSZQhk8mVIgRg9fZisqeMvM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_56bc99903928f81341881786",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "source": "generator",
      "poi_name": "UNC Charlotte Botanical Gardens",
      "poi_type": "Entertainment",
      "poi_address": "9090 Craver Rd, Charlotte, NC 28262, USA",
      "poi_short_description": "Indoor & outdoor displays of plants from around the world, plus workshops, plant sales & free tours.",
      "poi_long_description": "Indoor & outdoor displays of plants from around the world, plus workshops, plant sales & free tours.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1514-6578-75fc-b4cc-082ab8d82264.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1514-6578-75fc-b4cc-082ab8d82264",
        "storage_key": "property/5651440852795392/019f1514-6578-75fc-b4cc-082ab8d82264.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://gardens.uncc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4177973296962421892&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "unc-charlotte-botanical-gardens",
      "poi_latitude": "35.3078198",
      "poi_longitude": "-80.72969499999999",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 704-687-0721",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1514-7a3e-7595-933e-0923aed6f76f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1514-7a3e-7595-933e-0923aed6f76f",
        "storage_key": "property/5651440852795392/019f1514-7a3e-7595-933e-0923aed6f76f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJA6cM9xocVIgRhESD5pMk-zk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "botanical_garden"
    },
    {
      "id": "ec_2fe7a390ceff5b255aac30e6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "source": "generator",
      "poi_name": "AMC Northlake 14",
      "poi_type": "Entertainment",
      "poi_address": "7325 Northlake Mall Dr, Charlotte, NC 28216, USA",
      "poi_short_description": "Comfortable theater featuring reclining seats, clean toilets and kind staff.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1517-645d-713e-a5ad-35fc7d6abd94.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1517-645d-713e-a5ad-35fc7d6abd94",
        "storage_key": "property/5651440852795392/019f1517-645d-713e-a5ad-35fc7d6abd94.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.amctheatres.com/movie-theatres/charlotte/amc-northlake-14?utm_medium=organic&utm_source=google&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=11641706098324670943&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amc-northlake-14",
      "poi_latitude": "35.353584",
      "poi_longitude": "-80.850346",
      "poi_miles_from_property": "9.1 mi",
      "poi_walking_minutes": "3 hours 23 mins",
      "poi_biking_minutes": "59 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 704-596-2137",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1517-a015-734d-bc27-cd1e43bbb5b3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1517-a015-734d-bc27-cd1e43bbb5b3",
        "storage_key": "property/5651440852795392/019f1517-a015-734d-bc27-cd1e43bbb5b3.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJb55buKunVogR3wkkGgSmj6E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "ec_37d93126790ba7bd13a35b88",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "source": "generator",
      "poi_name": "Escapology Escape Rooms Charlotte",
      "poi_type": "Entertainment",
      "poi_address": "9717 Northlake Centre Pkwy Ste B2 #B2, Charlotte, NC 28216, USA",
      "poi_short_description": "Entertainment venue offering themed escape rooms and birthday parties.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1517-65dd-70dd-8c3a-d316e6897aa8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1517-65dd-70dd-8c3a-d316e6897aa8",
        "storage_key": "property/5651440852795392/019f1517-65dd-70dd-8c3a-d316e6897aa8.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.escapology.com/en/charlotte-nc",
      "poi_directions_map_url": "https://maps.google.com/?cid=16970146391042616947&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "escapology-escape-rooms-charlotte",
      "poi_latitude": "35.3476421",
      "poi_longitude": "-80.8595916",
      "poi_miles_from_property": "9.1 mi",
      "poi_walking_minutes": "3 hours 24 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 704-995-0578",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1514-7a3e-7595-933e-0923aed6f76f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1514-7a3e-7595-933e-0923aed6f76f",
        "storage_key": "property/5651440852795392/019f1514-7a3e-7595-933e-0923aed6f76f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJDUrIYLanVogRc-54IDsSgus",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "ec_d9dc76c3cfdf5dcbdf6ad033",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "source": "generator",
      "poi_name": "U.S. National Whitewater Center",
      "poi_type": "Entertainment",
      "poi_address": "5000 Whitewater Center Pkwy, Charlotte, NC 28214, USA",
      "poi_short_description": "Recreation grounds with whitewater rafting, canoeing, kayaking, rappelling, rock climbing & more.",
      "poi_long_description": "Recreation grounds with whitewater rafting, canoeing, kayaking, rappelling, rock climbing & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1517-6b63-7429-9ac2-8816160ca3d4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1517-6b63-7429-9ac2-8816160ca3d4",
        "storage_key": "property/5651440852795392/019f1517-6b63-7429-9ac2-8816160ca3d4.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.whitewater.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11500212967885119010&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "us-national-whitewater-center",
      "poi_latitude": "35.2712966",
      "poi_longitude": "-81.00554029999999",
      "poi_miles_from_property": "16.8 mi",
      "poi_walking_minutes": "6 hours 11 mins",
      "poi_biking_minutes": "1 hour 36 mins",
      "poi_driving_minutes": "25 mins",
      "poi_business_phone": "+1 704-391-3900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1514-7a1b-754e-a9a3-dc9613cbae24.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1514-7a1b-754e-a9a3-dc9613cbae24",
        "storage_key": "property/5651440852795392/019f1514-7a1b-754e-a9a3-dc9613cbae24.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJvd734yC9VogRIh4ieMP2mJ8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_c240cf85106f615b6d789f73",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "source": "generator",
      "poi_name": "SEA LIFE Charlotte-Concord",
      "poi_type": "Entertainment",
      "poi_address": "8111 Concord Mills Boulevard, Concord, NC 28027, USA",
      "poi_short_description": "Family-friendly exhibits with a variety of sea creatures (most offer play areas & group packages).",
      "poi_long_description": "Family-friendly exhibits with a variety of sea creatures (most offer play areas & group packages).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1514-4cad-7387-b60c-c9597217546a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1514-4cad-7387-b60c-c9597217546a",
        "storage_key": "property/5651440852795392/019f1514-4cad-7387-b60c-c9597217546a.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.visitsealife.com/charlotte-concord/?utm_source=local-listing&utm_medium=organic&utm_campaign=tickets",
      "poi_directions_map_url": "https://maps.google.com/?cid=7728186963408053643&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sea-life-charlotte-concord",
      "poi_latitude": "35.3692328",
      "poi_longitude": "-80.72510779999999",
      "poi_miles_from_property": "10.8 mi",
      "poi_walking_minutes": "3 hours 58 mins",
      "poi_biking_minutes": "53 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 704-456-1955",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1514-7a3e-7595-933e-0923aed6f76f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1514-7a3e-7595-933e-0923aed6f76f",
        "storage_key": "property/5651440852795392/019f1514-7a3e-7595-933e-0923aed6f76f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJR0LDIaccVIgRi-W99xgJQGs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "aquarium"
    },
    {
      "id": "ec_f26eb2ddd3261316993806fd",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "source": "generator",
      "poi_name": "Carowinds",
      "poi_type": "Entertainment",
      "poi_address": "North Carolina, USA",
      "poi_short_description": "Seasonal, family-friendly amusement park featuring towering roller coasters, waterslides & more.",
      "poi_long_description": "Seasonal, family-friendly amusement park featuring towering roller coasters, waterslides & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1517-64d1-73fc-9737-e8442cd8b2a8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1517-64d1-73fc-9737-e8442cd8b2a8",
        "storage_key": "property/5651440852795392/019f1517-64d1-73fc-9737-e8442cd8b2a8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.carowinds.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3638331865982573054&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "carowinds",
      "poi_latitude": "35.1024013",
      "poi_longitude": "-80.9412735",
      "poi_miles_from_property": "19.2 mi",
      "poi_walking_minutes": "7 hours 8 mins",
      "poi_biking_minutes": "2 hours 2 mins",
      "poi_driving_minutes": "29 mins",
      "poi_business_phone": "+1 704-588-2600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1514-7a3e-7595-933e-0923aed6f76f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1514-7a3e-7595-933e-0923aed6f76f",
        "storage_key": "property/5651440852795392/019f1514-7a3e-7595-933e-0923aed6f76f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJLVWj3q-PVogR_hngLo7zfTI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "ec_ea263cb6d5de4c5e38070bda",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "source": "generator",
      "poi_name": "The Evening Muse",
      "poi_type": "Entertainment",
      "poi_address": "3227 N Davidson St, Charlotte, NC 28205, USA",
      "poi_short_description": "Intimate venue hosting touring bands of various genres, from country to ska, in a smoke-free room.",
      "poi_long_description": "Intimate venue hosting touring bands of various genres, from country to ska, in a smoke-free room.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1517-69e0-71b5-9ed0-b4735d1a3cfa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1517-69e0-71b5-9ed0-b4735d1a3cfa",
        "storage_key": "property/5651440852795392/019f1517-69e0-71b5-9ed0-b4735d1a3cfa.webp",
        "width": 1237,
        "height": 582
      },
      "poi_business_url": "http://www.eveningmuse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2250801020014088509&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-evening-muse",
      "poi_latitude": "35.2477153",
      "poi_longitude": "-80.8048093",
      "poi_miles_from_property": "4.5 mi",
      "poi_walking_minutes": "1 hour 41 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 704-376-3737",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1514-7a3e-7595-933e-0923aed6f76f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1514-7a3e-7595-933e-0923aed6f76f",
        "storage_key": "property/5651440852795392/019f1514-7a3e-7595-933e-0923aed6f76f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQYzg9tkfVIgRPdEGOppzPB8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "live_music_venue"
    },
    {
      "id": "ec_96ec0da5759a240586db63cb",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "source": "generator",
      "poi_name": "Neighborhood Theatre",
      "poi_type": "Entertainment",
      "poi_address": "511 E 36th St, Charlotte, NC 28205, USA",
      "poi_short_description": "Live music venue hosting acts in a variety of genres & DJ-driven parties, with VIP seating & bar.",
      "poi_long_description": "Live music venue hosting acts in a variety of genres & DJ-driven parties, with VIP seating & bar.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1517-658e-74df-84a0-54967c6aa696.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1517-658e-74df-84a0-54967c6aa696",
        "storage_key": "property/5651440852795392/019f1517-658e-74df-84a0-54967c6aa696.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.neighborhoodtheatre.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12242965911959922312&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "neighborhood-theatre",
      "poi_latitude": "35.24740930000001",
      "poi_longitude": "-80.8040699",
      "poi_miles_from_property": "4.6 mi",
      "poi_walking_minutes": "1 hour 41 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 704-942-7997",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1514-7a3e-7595-933e-0923aed6f76f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1514-7a3e-7595-933e-0923aed6f76f",
        "storage_key": "property/5651440852795392/019f1514-7a3e-7595-933e-0923aed6f76f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJl94FGdofVIgRiGaWg6HA56k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "live_music_venue"
    },
    {
      "id": "ec_4534ee8528d0b5914b7c6fe9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "source": "generator",
      "poi_name": "Discovery Place Science",
      "poi_type": "Entertainment",
      "poi_address": "168 W 6th St, Charlotte, NC 28202, USA",
      "poi_short_description": "Kids' science & tech museum with interactive exhibits, an aquarium, rain forest & IMAX theater.",
      "poi_long_description": "Kids' science & tech museum with interactive exhibits, an aquarium, rain forest & IMAX theater.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1514-4971-7695-87b8-613ca5e763d4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1514-4971-7695-87b8-613ca5e763d4",
        "storage_key": "property/5651440852795392/019f1514-4971-7695-87b8-613ca5e763d4.webp",
        "width": 1200,
        "height": 800
      },
      "poi_business_url": "http://discoveryplace.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8672994214166199027&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "discovery-place-science",
      "poi_latitude": "35.229441",
      "poi_longitude": "-80.8409271",
      "poi_miles_from_property": "6.8 mi",
      "poi_walking_minutes": "2 hours 34 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 704-327-2189",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1514-7a2f-7087-bb83-85bf22229972.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1514-7a2f-7087-bb83-85bf22229972",
        "storage_key": "property/5651440852795392/019f1514-7a2f-7087-bb83-85bf22229972.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ-LB1SSgVogR8_pkSkmqXHg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "ec_8d1ab5d640ce5870e5b5140d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "source": "generator",
      "poi_name": "Mint Museum Uptown",
      "poi_type": "Entertainment",
      "poi_address": "at Levine Center for the Arts, 500 S Tryon St, Charlotte, NC 28202, USA",
      "poi_short_description": "Museum showcasing international art, plus live performances & educational programs for all ages.",
      "poi_long_description": "Museum showcasing international art, plus live performances & educational programs for all ages.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1517-6a4b-7300-a8d7-8d25b678c43e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1517-6a4b-7300-a8d7-8d25b678c43e",
        "storage_key": "property/5651440852795392/019f1517-6a4b-7300-a8d7-8d25b678c43e.webp",
        "width": 1280,
        "height": 977
      },
      "poi_business_url": "http://mintmuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3574976966142914753&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mint-museum-uptown",
      "poi_latitude": "35.2244083",
      "poi_longitude": "-80.8480847",
      "poi_miles_from_property": "7.4 mi",
      "poi_walking_minutes": "2 hours 46 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 704-337-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1514-7a2f-7087-bb83-85bf22229972.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1514-7a2f-7087-bb83-85bf22229972",
        "storage_key": "property/5651440852795392/019f1514-7a2f-7087-bb83-85bf22229972.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6QA5TymgVogRwfAmE5zenDE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_museum"
    },
    {
      "id": "ec_89ade33f1f24ff7b8ded43e8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "source": "generator",
      "poi_name": "Atrium Health University City",
      "poi_type": "Health and Wellness",
      "poi_address": "8800 N Tryon St, Charlotte, NC 28262, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1514-64c8-73ae-ba2a-765d481f562d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1514-64c8-73ae-ba2a-765d481f562d",
        "storage_key": "property/5651440852795392/019f1514-64c8-73ae-ba2a-765d481f562d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://atriumhealth.org/locations/detail/atrium-health-university-city?utm_source=GMB&utm_medium=Organic&utm_campaign=GCR",
      "poi_directions_map_url": "https://maps.google.com/?cid=7076796399763319050&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "atrium-health-university-city",
      "poi_latitude": "35.3066306",
      "poi_longitude": "-80.7472512",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 704-863-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1514-7a99-7298-aac8-8b288921d830.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1514-7a99-7298-aac8-8b288921d830",
        "storage_key": "property/5651440852795392/019f1514-7a99-7298-aac8-8b288921d830.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJpeG8ryMcVIgRCumnw9TUNWI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_8e447a9470a5f1bb5cb6a279",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "source": "generator",
      "poi_name": "Atrium Health Urgent Care",
      "poi_type": "Health and Wellness",
      "poi_address": "9325 JW Clay Blvd Ste 221, Charlotte, NC 28262, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1517-7192-721a-944a-c6726c92cae1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1517-7192-721a-944a-c6726c92cae1",
        "storage_key": "property/5651440852795392/019f1517-7192-721a-944a-c6726c92cae1.webp",
        "width": 855,
        "height": 1280
      },
      "poi_business_url": "https://atriumhealth.org/locations/detail/atrium-health-urgent-care-university-city?utm_source=GMB&utm_medium=Organic&utm_campaign=GCR",
      "poi_directions_map_url": "https://maps.google.com/?cid=5661548961259477027&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "atrium-health-urgent-care",
      "poi_latitude": "35.3107795",
      "poi_longitude": "-80.7457122",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 704-863-9050",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1514-7a3e-7595-933e-0923aed6f76f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1514-7a3e-7595-933e-0923aed6f76f",
        "storage_key": "property/5651440852795392/019f1514-7a3e-7595-933e-0923aed6f76f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJwUFVFxgdVIgRI1hausjckU4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_262d04c17314fea7cfeb16d1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "source": "generator",
      "poi_name": "MainStreet Family Care",
      "poi_type": "Health and Wellness",
      "poi_address": "10039 University City Blvd A, Charlotte, NC 28213, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1517-6bba-75fb-ab2f-914aca939fe3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1517-6bba-75fb-ab2f-914aca939fe3",
        "storage_key": "property/5651440852795392/019f1517-6bba-75fb-ab2f-914aca939fe3.webp",
        "width": 913,
        "height": 1280
      },
      "poi_business_url": "https://www.mainstreetfamilycare.com/locations/charlotte/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11025492104538912437&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mainstreet-family-care",
      "poi_latitude": "35.3107921",
      "poi_longitude": "-80.7161778",
      "poi_miles_from_property": "3.2 mi",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 704-625-2594",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1514-7a3e-7595-933e-0923aed6f76f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1514-7a3e-7595-933e-0923aed6f76f",
        "storage_key": "property/5651440852795392/019f1514-7a3e-7595-933e-0923aed6f76f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJwf1yDT0bVIgRtXbqTKdqApk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_3603be8ddab99461eec5abf5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "source": "generator",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "10215 University City Blvd B, Charlotte, NC 28213, USA",
      "poi_short_description": "Chain gym featuring a variety of equipment, tanning beds, and 24-hour access.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1514-4fa3-774c-b758-562cce587224.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1514-4fa3-774c-b758-562cce587224",
        "storage_key": "property/5651440852795392/019f1514-4fa3-774c-b758-562cce587224.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/charlotte-university-blvd-nc?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=15550441792175585086&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "35.31210069999999",
      "poi_longitude": "-80.713909",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 704-548-2722",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1514-7a3e-7595-933e-0923aed6f76f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1514-7a3e-7595-933e-0923aed6f76f",
        "storage_key": "property/5651440852795392/019f1514-7a3e-7595-933e-0923aed6f76f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJdYakZvEbVIgRPrcDk2tEztc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_21df5dd967212c76335adbc5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "source": "generator",
      "poi_name": "Orangetheory Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "601 S Kings Dr Ste J, Charlotte, NC 28204, USA",
      "poi_short_description": "Chain fitness center offering full-body workouts that blend cardio and strength training.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1517-7779-718c-8b86-b57c92dd84b9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1517-7779-718c-8b86-b57c92dd84b9",
        "storage_key": "property/5651440852795392/019f1517-7779-718c-8b86-b57c92dd84b9.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.orangetheory.com/en-us/locations/charlotte-north-carolina-0999?utm_medium=seo&utm_source=gg&utm_term=corporate&utm_campaign=soci",
      "poi_directions_map_url": "https://maps.google.com/?cid=9759776868597648337&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "orangetheory-fitness",
      "poi_latitude": "35.2094051",
      "poi_longitude": "-80.8356641",
      "poi_miles_from_property": "7.8 mi",
      "poi_walking_minutes": "2 hours 53 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 704-412-9612",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1514-7a3e-7595-933e-0923aed6f76f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1514-7a3e-7595-933e-0923aed6f76f",
        "storage_key": "property/5651440852795392/019f1514-7a3e-7595-933e-0923aed6f76f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJiwV5zSmfVogR0UvWO1qxcYc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_ce829aa52b68d6505fd34906",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "source": "generator",
      "poi_name": "UNC Charlotte University Recreation Center (UREC)",
      "poi_type": "Health and Wellness",
      "poi_address": "8827 Craver Rd, Charlotte, NC 28262, USA",
      "poi_short_description": "Recreation center with 5 floors, 2 pools, a sand volleyball court, and a weight room, plus group fitness classes.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1517-70e0-740f-9ee7-ff13e34eef5d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1517-70e0-740f-9ee7-ff13e34eef5d",
        "storage_key": "property/5651440852795392/019f1517-70e0-740f-9ee7-ff13e34eef5d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://urec.charlotte.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9436810648187106495&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "unc-charlotte-university-recreation-center-urec",
      "poi_latitude": "35.308374",
      "poi_longitude": "-80.735112",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 704-687-1385",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1514-7a5f-72e0-9de4-510c24564d63.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1514-7a5f-72e0-9de4-510c24564d63",
        "storage_key": "property/5651440852795392/019f1514-7a5f-72e0-9de4-510c24564d63.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJHXT-SnMdVIgRv_TQQUlJ9oI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "academic_department"
    },
    {
      "id": "ec_8bceb381980f35b631452ec3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "source": "generator",
      "poi_name": "Target",
      "poi_type": "Health and Wellness",
      "poi_address": "8120 University City Blvd, Charlotte, NC 28213, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1517-5a8e-7716-a794-81e56f5da1e6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1517-5a8e-7716-a794-81e56f5da1e6",
        "storage_key": "property/5651440852795392/019f1517-5a8e-7716-a794-81e56f5da1e6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.target.com/sl/ne-charlotte/1081",
      "poi_directions_map_url": "https://maps.google.com/?cid=13592394189975419888&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "target",
      "poi_latitude": "35.2929967",
      "poi_longitude": "-80.74573989999999",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 704-599-6332",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1514-7a2f-7087-bb83-81f136a1eaa8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1514-7a2f-7087-bb83-81f136a1eaa8",
        "storage_key": "property/5651440852795392/019f1514-7a2f-7087-bb83-81f136a1eaa8.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ05zW0ZgeVIgR8HuRDIDiobw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "ec_46b862ead95b32c06057ec8e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "source": "generator",
      "poi_name": "Walgreens",
      "poi_type": "Health and Wellness",
      "poi_address": "8538 N Tryon St, Charlotte, NC 28262, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1517-7522-75a6-85bf-6a6954a00f29.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1517-7522-75a6-85bf-6a6954a00f29",
        "storage_key": "property/5651440852795392/019f1517-7522-75a6-85bf-6a6954a00f29.webp",
        "width": 1280,
        "height": 598
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-8538+n+tryon+st-charlotte-nc-28262/id=4547",
      "poi_directions_map_url": "https://maps.google.com/?cid=9712234873269453930&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "35.30457740000001",
      "poi_longitude": "-80.7496324",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 704-547-8551",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1514-7a3e-7595-933e-0923aed6f76f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1514-7a3e-7595-933e-0923aed6f76f",
        "storage_key": "property/5651440852795392/019f1514-7a3e-7595-933e-0923aed6f76f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJj7dKASQcVIgRagRj3CjKyIY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "ec_9e4d18cae74052a06da35a6a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "source": "generator",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Health and Wellness",
      "poi_address": "7735 N Tryon St, Charlotte, NC 28262, USA",
      "poi_short_description": "Grocery store, pharmacy, clothing, furniture, sporting goods, electronics, home goods and sporting goods retailer featuring clothing, housewares, electronics and groceries.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1517-701e-74a3-a6ae-ce524d6a9884.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1517-701e-74a3-a6ae-ce524d6a9884",
        "storage_key": "property/5651440852795392/019f1517-701e-74a3-a6ae-ce524d6a9884.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/2134-charlotte-nc/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=7693588847703310125&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "35.2951583",
      "poi_longitude": "-80.7581024",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 704-547-0525",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1514-7a2f-7087-bb83-81f136a1eaa8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1514-7a2f-7087-bb83-81f136a1eaa8",
        "storage_key": "property/5651440852795392/019f1514-7a2f-7087-bb83-81f136a1eaa8.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ9wzzDDAcVIgRLT9Da0sexWo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "ec_07844575b1127b6514d3565e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "source": "generator",
      "poi_name": "OrthoCarolina Urgent Care University",
      "poi_type": "Health and Wellness",
      "poi_address": "9848 N Tryon St, Charlotte, NC 28262, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1517-76c9-7560-bdc9-ad276de11bea.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1517-76c9-7560-bdc9-ad276de11bea",
        "storage_key": "property/5651440852795392/019f1517-76c9-7560-bdc9-ad276de11bea.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.orthocarolina.com/locations/university-urgent-care?utm_medium=OrthoCarolinaUrgentCareUniversity&utm_source=GMBSocialClimb",
      "poi_directions_map_url": "https://maps.google.com/?cid=1648732870584484011&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "orthocarolina-urgent-care-university",
      "poi_latitude": "35.3196206",
      "poi_longitude": "-80.7349521",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 704-323-2104",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1514-7a3e-7595-933e-0923aed6f76f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1514-7a3e-7595-933e-0923aed6f76f",
        "storage_key": "property/5651440852795392/019f1514-7a3e-7595-933e-0923aed6f76f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJzaN7K20cVIgRq8CyeM954RY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_a5e83ace4cb4c8c509b8290c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "source": "generator",
      "poi_name": "Tom Hunter Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "919 Tom Hunter Rd, Charlotte, NC 28213, USA",
      "poi_short_description": "Children's play areas and picnic tables at a park with a basketball court.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1517-7919-73e6-b52d-437eb437570e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1517-7919-73e6-b52d-437eb437570e",
        "storage_key": "property/5651440852795392/019f1517-7919-73e6-b52d-437eb437570e.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=3034716072445602436&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tom-hunter-park",
      "poi_latitude": "35.2772068",
      "poi_longitude": "-80.78143419999999",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 980-314-1001",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1514-7a1b-754e-a9a3-dc9613cbae24.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1514-7a1b-754e-a9a3-dc9613cbae24",
        "storage_key": "property/5651440852795392/019f1514-7a1b-754e-a9a3-dc9613cbae24.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJWUrSM0IeVIgRhOpJdDB6HSo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_8f3554d5a496217dba8d89b1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "source": "generator",
      "poi_name": "Toby Creek Greenway - Ruth G. Shaw Trailhead (2 miles)",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "8541 University City Blvd, Charlotte, NC 28213, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1517-7a92-75fa-85fa-5d43483dbca4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1517-7a92-75fa-85fa-5d43483dbca4",
        "storage_key": "property/5651440852795392/019f1517-7a92-75fa-85fa-5d43483dbca4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.carolinathreadtrail.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13519428957779332624&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "toby-creek-greenway---ruth-g-shaw-trailhead-2-miles",
      "poi_latitude": "35.2968741",
      "poi_longitude": "-80.7414333",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 704-376-2556",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1514-7a3e-7595-933e-0923aed6f76f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1514-7a3e-7595-933e-0923aed6f76f",
        "storage_key": "property/5651440852795392/019f1514-7a3e-7595-933e-0923aed6f76f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ73PsZ6AeVIgREA6REgKpnrs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hiking_area"
    },
    {
      "id": "ec_834f02b718d87ce7583c952c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "source": "generator",
      "poi_name": "UNC Charlotte Botanical Gardens",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "9090 Craver Rd, Charlotte, NC 28262, USA",
      "poi_short_description": "Indoor & outdoor displays of plants from around the world, plus workshops, plant sales & free tours.",
      "poi_long_description": "Indoor & outdoor displays of plants from around the world, plus workshops, plant sales & free tours.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1514-6578-75fc-b4cc-082ab8d82264.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1514-6578-75fc-b4cc-082ab8d82264",
        "storage_key": "property/5651440852795392/019f1514-6578-75fc-b4cc-082ab8d82264.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://gardens.uncc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4177973296962421892&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "unc-charlotte-botanical-gardens",
      "poi_latitude": "35.3078198",
      "poi_longitude": "-80.72969499999999",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 704-687-0721",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1514-7a3e-7595-933e-0923aed6f76f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1514-7a3e-7595-933e-0923aed6f76f",
        "storage_key": "property/5651440852795392/019f1514-7a3e-7595-933e-0923aed6f76f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJA6cM9xocVIgRhESD5pMk-zk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "botanical_garden"
    },
    {
      "id": "ec_c7c6ee884d9601354bef75e9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "source": "generator",
      "poi_name": "Reedy Creek Nature Center",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2986 ROCKY RIVER RD, Charlotte, NC 28215, USA",
      "poi_short_description": "Nature center with animals & a gift shop in a 927-acre preserve with fishing, hiking & more.",
      "poi_long_description": "Nature center with animals & a gift shop in a 927-acre preserve with fishing, hiking & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1517-78f9-750d-901f-df7ea11fef51.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1517-78f9-750d-901f-df7ea11fef51",
        "storage_key": "property/5651440852795392/019f1517-78f9-750d-901f-df7ea11fef51.webp",
        "width": 1280,
        "height": 958
      },
      "poi_business_url": "https://parkandrec.mecknc.gov/Places-to-Visit/Nature/reedy-creek-nature-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=3576989697573525763&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "reedy-creek-nature-center",
      "poi_latitude": "35.261767",
      "poi_longitude": "-80.71938000000002",
      "poi_miles_from_property": "4.7 mi",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 980-314-1119",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1514-7a1b-754e-a9a3-dc9613cbae24.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1514-7a1b-754e-a9a3-dc9613cbae24",
        "storage_key": "property/5651440852795392/019f1514-7a1b-754e-a9a3-dc9613cbae24.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJRRFBPi0ZVIgRAxkaoS0FpDE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nature_preserve"
    },
    {
      "id": "ec_f1f880efcb60d29215593168",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "source": "generator",
      "poi_name": "The Shoppes at University Place",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "8931 J M Keynes Dr, Charlotte, NC 28262, USA",
      "poi_short_description": "Shopping center with restaurants and stores, plus a boardwalk with paddleboats.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1517-7a39-724e-8391-02f116b4a27d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1517-7a39-724e-8391-02f116b4a27d",
        "storage_key": "property/5651440852795392/019f1517-7a39-724e-8391-02f116b4a27d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://shoppesatuniversityplace.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14212933022838765680&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-shoppes-at-university-place",
      "poi_latitude": "35.309802",
      "poi_longitude": "-80.748663",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1514-7a2f-7087-bb83-81f136a1eaa8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1514-7a2f-7087-bb83-81f136a1eaa8",
        "storage_key": "property/5651440852795392/019f1514-7a2f-7087-bb83-81f136a1eaa8.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ_Wp0EEIdVIgRcDi56kd7PsU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_ea3981a7baa7c9042c8366ed",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "source": "generator",
      "poi_name": "Mallard Creek Greenway - East Terminus",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "201 E Mallard Creek Church Rd, Charlotte, NC 28262, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1517-8223-70bc-a0f0-c8774fe36874.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1517-8223-70bc-a0f0-c8774fe36874",
        "storage_key": "property/5651440852795392/019f1517-8223-70bc-a0f0-c8774fe36874.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.mecknc.gov/ParkandRec/Greenways/OpenGreenways/Pages/MallardCreekandClark'sCreek.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=15209037215157520469&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mallard-creek-greenway---east-terminus",
      "poi_latitude": "35.32064940000001",
      "poi_longitude": "-80.73165089999999",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 980-314-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1514-7a3e-7595-933e-0923aed6f76f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1514-7a3e-7595-933e-0923aed6f76f",
        "storage_key": "property/5651440852795392/019f1514-7a3e-7595-933e-0923aed6f76f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUaiP2cwdVIgRVQgpKcRaEdM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hiking_area"
    },
    {
      "id": "ec_0229c9f154e8f41a858f5ec1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "source": "generator",
      "poi_name": "Waddell Street Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1505 Waddell St, Charlotte, NC 28216, USA",
      "poi_short_description": "Relaxed, clean, neighborhood park featuring a baseball field, a grill and playground equipment.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1517-8208-709b-94cc-63824d027766.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1517-8208-709b-94cc-63824d027766",
        "storage_key": "property/5651440852795392/019f1517-8208-709b-94cc-63824d027766.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=14344364743413533813&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "waddell-street-park",
      "poi_latitude": "35.2547046",
      "poi_longitude": "-80.8466933",
      "poi_miles_from_property": "6.5 mi",
      "poi_walking_minutes": "2 hours 24 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 704-432-4280",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1514-7a1b-754e-a9a3-dc9613cbae24.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1514-7a1b-754e-a9a3-dc9613cbae24",
        "storage_key": "property/5651440852795392/019f1514-7a1b-754e-a9a3-dc9613cbae24.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJjcCuB1GgVogRdQzNA7xrEcc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_4e60b98e46b0efdee0e47c34",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "source": "generator",
      "poi_name": "McAlpine Creek Greenway Trailhead",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "110 Old Bell Rd, Charlotte, NC 28270, USA",
      "poi_short_description": "Popular paved greenway with a pond, picnic area, restrooms, and dog park, plus wildlife sightings.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1517-82d1-71ec-bda4-32e6b9dd6092.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1517-82d1-71ec-bda4-32e6b9dd6092",
        "storage_key": "property/5651440852795392/019f1517-82d1-71ec-bda4-32e6b9dd6092.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=1957761888640240409&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mcalpine-creek-greenway-trailhead",
      "poi_latitude": "35.136245",
      "poi_longitude": "-80.7674631",
      "poi_miles_from_property": "12.3 mi",
      "poi_walking_minutes": "4 hours 32 mins",
      "poi_biking_minutes": "1 hour 12 mins",
      "poi_driving_minutes": "28 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1514-7a3e-7595-933e-0923aed6f76f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1514-7a3e-7595-933e-0923aed6f76f",
        "storage_key": "property/5651440852795392/019f1514-7a3e-7595-933e-0923aed6f76f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ09KJ4JQhVIgRGQszpxBeKxs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hiking_area"
    },
    {
      "id": "ec_398d8977a19b05ecd9a2cfe6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "source": "generator",
      "poi_name": "University City Blvd",
      "poi_type": "Transportation & Transit",
      "poi_address": "7205 N Tryon St, Charlotte, NC 28262, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1514-6cee-7769-b665-5a32f9372532.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1514-6cee-7769-b665-5a32f9372532",
        "storage_key": "property/5651440852795392/019f1514-6cee-7769-b665-5a32f9372532.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://charlonbvcsattenc.gov/cats/Pages/default.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=12467337922677263454&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-city-blvd",
      "poi_latitude": "35.2869215",
      "poi_longitude": "-80.76073650000001",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1514-7a3e-7595-933e-0923aed6f76f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1514-7a3e-7595-933e-0923aed6f76f",
        "storage_key": "property/5651440852795392/019f1514-7a3e-7595-933e-0923aed6f76f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZz4QjIUeVIgRXkzvL8nhBK0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "ec_91aa359565decf0aabc359d7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "source": "generator",
      "poi_name": "Tom Hunter Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "Charlotte, NC 28213, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1517-8124-742b-b993-842bfdc093d9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1517-8124-742b-b993-842bfdc093d9",
        "storage_key": "property/5651440852795392/019f1517-8124-742b-b993-842bfdc093d9.webp",
        "width": 719,
        "height": 490
      },
      "poi_business_url": "http://charlottenc.gov/cats/Pages/default.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=2039373716308956755&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tom-hunter-station",
      "poi_latitude": "35.2779461",
      "poi_longitude": "-80.76628629999999",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1514-7a3e-7595-933e-0923aed6f76f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1514-7a3e-7595-933e-0923aed6f76f",
        "storage_key": "property/5651440852795392/019f1514-7a3e-7595-933e-0923aed6f76f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5VbfjF8eVIgRUxbdBJdPTRw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "ec_1e7d0c00388fd2a83ddb832a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "source": "generator",
      "poi_name": "Old Concord Road Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "Charlotte, NC 28213, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1514-6e88-718c-bcc5-6549dbdc443a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1514-6e88-718c-bcc5-6549dbdc443a",
        "storage_key": "property/5651440852795392/019f1514-6e88-718c-bcc5-6549dbdc443a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://charlottenc.gov/cats/Pages/default.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=15125097527445389047&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "old-concord-road-station",
      "poi_latitude": "35.2599158",
      "poi_longitude": "-80.77273230000002",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1514-7a3e-7595-933e-0923aed6f76f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1514-7a3e-7595-933e-0923aed6f76f",
        "storage_key": "property/5651440852795392/019f1514-7a3e-7595-933e-0923aed6f76f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJCZhR5lMeVIgR936FpBAk59E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "ec_491b5025fc5b454738818746",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "source": "generator",
      "poi_name": "McCullough",
      "poi_type": "Transportation & Transit",
      "poi_address": "8312 N Tryon St, Charlotte, NC 28262, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1517-8985-7199-af14-75a400c51a30.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1517-8985-7199-af14-75a400c51a30",
        "storage_key": "property/5651440852795392/019f1517-8985-7199-af14-75a400c51a30.webp",
        "width": 1280,
        "height": 674
      },
      "poi_business_url": "http://charlottenc.gov/cats/rail/lynx-blue-line/Pages/mccullough-station.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=1260187329938804696&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mccullough",
      "poi_latitude": "35.301124",
      "poi_longitude": "-80.752875",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1514-7a3e-7595-933e-0923aed6f76f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1514-7a3e-7595-933e-0923aed6f76f",
        "storage_key": "property/5651440852795392/019f1514-7a3e-7595-933e-0923aed6f76f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJB_ReviccVIgR2E9zJ7MVfRE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "ec_7d4c895b6ccfd15a0d3fddb7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "source": "generator",
      "poi_name": "JW Clay Blvd / UNC Charlotte",
      "poi_type": "Transportation & Transit",
      "poi_address": "9234-9300 N Tryon St, Charlotte, NC 28262, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1517-871b-73fb-bbb3-fcf043d81ea6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1517-871b-73fb-bbb3-fcf043d81ea6",
        "storage_key": "property/5651440852795392/019f1517-871b-73fb-bbb3-fcf043d81ea6.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.charlottenc.gov/CATS/Rail/LYNX-Stations-and-Park-and-Rides/JW-Clay-Station",
      "poi_directions_map_url": "https://maps.google.com/?cid=9941066239111075827&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jw-clay-blvd--unc-charlotte",
      "poi_latitude": "35.3108328",
      "poi_longitude": "-80.7450265",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1514-7a3e-7595-933e-0923aed6f76f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1514-7a3e-7595-933e-0923aed6f76f",
        "storage_key": "property/5651440852795392/019f1514-7a3e-7595-933e-0923aed6f76f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5wiIej0cVIgR8xfYDhPD9Yk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "ec_90d6e711435c92fe3ac15b68",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "source": "generator",
      "poi_name": "UNC Charlotte Main Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "9025 Cameron Blvd, Charlotte, NC 28262, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1514-6b1a-7787-886c-784925546315.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1514-6b1a-7787-886c-784925546315",
        "storage_key": "property/5651440852795392/019f1514-6b1a-7787-886c-784925546315.webp",
        "width": 1280,
        "height": 957
      },
      "poi_business_url": "http://charlottenc.gov/cats/Pages/default.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=11588625435149076740&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "unc-charlotte-main-station",
      "poi_latitude": "35.3121822",
      "poi_longitude": "-80.73371980000002",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1514-7a3e-7595-933e-0923aed6f76f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1514-7a3e-7595-933e-0923aed6f76f",
        "storage_key": "property/5651440852795392/019f1514-7a3e-7595-933e-0923aed6f76f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJDTHpFBEcVIgRBAkeIW8R06A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "ec_c10388bd058aa107981288c1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "source": "generator",
      "poi_name": "Charlotte",
      "poi_type": "Transportation & Transit",
      "poi_address": "1914 N Tryon St, Charlotte, NC 28206, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1517-8650-713f-bb8a-f3810d96406d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1517-8650-713f-bb8a-f3810d96406d",
        "storage_key": "property/5651440852795392/019f1517-8650-713f-bb8a-f3810d96406d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.amtrak.com/servlet/ContentServer?pagename=am/am2Station/Station_Page&code=CLT",
      "poi_directions_map_url": "https://maps.google.com/?cid=9204761905035767858&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "charlotte",
      "poi_latitude": "35.241285",
      "poi_longitude": "-80.82270799999999",
      "poi_miles_from_property": "5.5 mi",
      "poi_walking_minutes": "2 hours 4 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 800-872-7245",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1514-7a3e-7595-933e-0923aed6f76f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1514-7a3e-7595-933e-0923aed6f76f",
        "storage_key": "property/5651440852795392/019f1514-7a3e-7595-933e-0923aed6f76f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJyS4qEG2gVogRMnC0By_ivX8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transit_station"
    },
    {
      "id": "ec_de94d2c68c9e54f3b5af8081",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "source": "generator",
      "poi_name": "Charlotte Transportation Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "310 E Trade St, Charlotte, NC 28202, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=4144275419840309105&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "charlotte-transportation-center",
      "poi_latitude": "35.2246882",
      "poi_longitude": "-80.8406333",
      "poi_miles_from_property": "7.2 mi",
      "poi_walking_minutes": "2 hours 42 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1514-7a3e-7595-933e-0923aed6f76f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1514-7a3e-7595-933e-0923aed6f76f",
        "storage_key": "property/5651440852795392/019f1514-7a3e-7595-933e-0923aed6f76f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJN63efwChVogRcef2eolsgzk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "ec_2c0ceddb9c9f0987f120632e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "source": "generator",
      "poi_name": "Charlotte Douglas International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "5501 Josh Birmingham Pkwy, Charlotte, NC 28208, USA",
      "poi_short_description": "Airport with rocking chairs, free WiFi & a 60-foot outdoor sculpture symbolizing flight.",
      "poi_long_description": "Airport with rocking chairs, free WiFi & a 60-foot outdoor sculpture symbolizing flight.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1517-8772-779a-930a-b7b97a116faf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1517-8772-779a-930a-b7b97a116faf",
        "storage_key": "property/5651440852795392/019f1517-8772-779a-930a-b7b97a116faf.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cltairport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1925933632275654455&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "charlotte-douglas-international-airport",
      "poi_latitude": "35.2162994",
      "poi_longitude": "-80.95394280000001",
      "poi_miles_from_property": "15.9 mi",
      "poi_walking_minutes": "5 hours 55 mins",
      "poi_biking_minutes": "1 hour 38 mins",
      "poi_driving_minutes": "25 mins",
      "poi_business_phone": "+1 704-359-4013",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1517-9ff5-764f-9a41-c781572e5988.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1517-9ff5-764f-9a41-c781572e5988",
        "storage_key": "property/5651440852795392/019f1517-9ff5-764f-9a41-c781572e5988.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJidRKt32YVogRN6fEPG9Kuho",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "ec_831aa6633fd8345d9a9c4815",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "source": "generator",
      "poi_name": "University of North Carolina at Charlotte",
      "poi_type": "Major Employers & Offices",
      "poi_address": "9201 University City Blvd, Charlotte, NC 28223, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1514-4858-76ec-9a25-e7d58a93f37f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1514-4858-76ec-9a25-e7d58a93f37f",
        "storage_key": "property/5651440852795392/019f1514-4858-76ec-9a25-e7d58a93f37f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.charlotte.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7728009800198595827&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-of-north-carolina-at-charlotte",
      "poi_latitude": "35.3074169",
      "poi_longitude": "-80.73521219999999",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 704-687-8622",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1514-7a5f-72e0-9de4-510c24564d63.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1514-7a5f-72e0-9de4-510c24564d63",
        "storage_key": "property/5651440852795392/019f1514-7a5f-72e0-9de4-510c24564d63.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJVyOp0BocVIgR8yST8fdnP2s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_7f6ac76a2b41fc6e6358be79",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "source": "generator",
      "poi_name": "Atrium Health University City",
      "poi_type": "Major Employers & Offices",
      "poi_address": "8800 N Tryon St, Charlotte, NC 28262, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1514-64c8-73ae-ba2a-765d481f562d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1514-64c8-73ae-ba2a-765d481f562d",
        "storage_key": "property/5651440852795392/019f1514-64c8-73ae-ba2a-765d481f562d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://atriumhealth.org/locations/detail/atrium-health-university-city?utm_source=GMB&utm_medium=Organic&utm_campaign=GCR",
      "poi_directions_map_url": "https://maps.google.com/?cid=7076796399763319050&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "atrium-health-university-city",
      "poi_latitude": "35.3066306",
      "poi_longitude": "-80.7472512",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 704-863-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1514-7a99-7298-aac8-8b288921d830.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1514-7a99-7298-aac8-8b288921d830",
        "storage_key": "property/5651440852795392/019f1514-7a99-7298-aac8-8b288921d830.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJpeG8ryMcVIgRCumnw9TUNWI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_51f60b297be177581d379550",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "source": "generator",
      "poi_name": "EPIC",
      "poi_type": "Major Employers & Offices",
      "poi_address": "8700 Phillips Rd, Charlotte, NC 28223, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1517-9017-7479-816f-d697bc93cb5a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1517-9017-7479-816f-d697bc93cb5a",
        "storage_key": "property/5651440852795392/019f1517-9017-7479-816f-d697bc93cb5a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://epic.uncc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11249946071795487627&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "epic",
      "poi_latitude": "35.3091165",
      "poi_longitude": "-80.7415523",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 704-687-8622",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1514-7a5f-72e0-9de4-510c24564d63.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1514-7a5f-72e0-9de4-510c24564d63",
        "storage_key": "property/5651440852795392/019f1514-7a5f-72e0-9de4-510c24564d63.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ-_VyiBccVIgRi9Or91jWH5w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "academic_department"
    },
    {
      "id": "ec_11e4166fc7dfe68f21ef0502",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "source": "generator",
      "poi_name": "Polymers Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "8900 Research Dr, Charlotte, NC 28262, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1517-90fa-776f-80c5-a93a32f09a0b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1517-90fa-776f-80c5-a93a32f09a0b",
        "storage_key": "property/5651440852795392/019f1517-90fa-776f-80c5-a93a32f09a0b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://polymers-center.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15458526078710124570&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "polymers-center",
      "poi_latitude": "35.3164765",
      "poi_longitude": "-80.757863",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 704-602-4100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1514-7a3e-7595-933e-0923aed6f76f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1514-7a3e-7595-933e-0923aed6f76f",
        "storage_key": "property/5651440852795392/019f1514-7a3e-7595-933e-0923aed6f76f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJIQgO2jYcVIgRGhCh2JC3h9Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "manufacturer"
    },
    {
      "id": "ec_f5d25df73465226a252cbd3c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "source": "generator",
      "poi_name": "TIAA-CREF main campus",
      "poi_type": "Major Employers & Offices",
      "poi_address": "8625 Andrew Carnegie Blvd, Charlotte, NC 28262, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1517-8eae-7533-bf91-cbe6a1083c65.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1517-8eae-7533-bf91-cbe6a1083c65",
        "storage_key": "property/5651440852795392/019f1517-8eae-7533-bf91-cbe6a1083c65.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=16683753304759355670&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tiaa-cref-main-campus",
      "poi_latitude": "35.3251646",
      "poi_longitude": "-80.7516294",
      "poi_miles_from_property": "3.7 mi",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 877-535-3910",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1514-7a3e-7595-933e-0923aed6f76f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1514-7a3e-7595-933e-0923aed6f76f",
        "storage_key": "property/5651440852795392/019f1514-7a3e-7595-933e-0923aed6f76f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4eYN40YcVIgRFklugjyZiOc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "business_center"
    },
    {
      "id": "ec_b27cabb1ecaca4945589a7b2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "source": "generator",
      "poi_name": "IBM Dr @ Innovation Park",
      "poi_type": "Major Employers & Offices",
      "poi_address": "Charlotte, NC 28262, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=14833931642041137435&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ibm-dr--innovation-park",
      "poi_latitude": "35.3042322",
      "poi_longitude": "-80.7641098",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1514-7a3e-7595-933e-0923aed6f76f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1514-7a3e-7595-933e-0923aed6f76f",
        "storage_key": "property/5651440852795392/019f1514-7a3e-7595-933e-0923aed6f76f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJo6rQaiscVIgRG_lJIjy23M0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "ec_002b9377e966b905d767c6d6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "source": "generator",
      "poi_name": "The Charlotte Observer",
      "poi_type": "Major Employers & Offices",
      "poi_address": "9140 Research Dr, Charlotte, NC 28262, USA",
      "poi_short_description": "Newspaper publication that's also a source for comics, classified ads and sports.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1517-9338-766a-a0c2-df7e4b8766eb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1517-9338-766a-a0c2-df7e4b8766eb",
        "storage_key": "property/5651440852795392/019f1517-9338-766a-a0c2-df7e4b8766eb.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://charlotteobserver.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=780677119238840944&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-charlotte-observer",
      "poi_latitude": "35.3216234",
      "poi_longitude": "-80.7598065",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 704-358-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1514-7a3e-7595-933e-0923aed6f76f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1514-7a3e-7595-933e-0923aed6f76f",
        "storage_key": "property/5651440852795392/019f1514-7a3e-7595-933e-0923aed6f76f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJO9lt6CugVogRcKKBKLSF1Qo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_ff8049bed8cd87babdcc7ae0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "source": "generator",
      "poi_name": "Novant Health Presbyterian Medical Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "200 Hawthorne Ln, Charlotte, NC 28204, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1517-96c8-72da-bc13-92be91fd2450.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1517-96c8-72da-bc13-92be91fd2450",
        "storage_key": "property/5651440852795392/019f1517-96c8-72da-bc13-92be91fd2450.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.novanthealth.org/locations/medical-centers/presbyterian-medical-center/?utm_source=maps.google.com&utm_medium=organic&utm_campaign=GBP&utm_content=MC-11",
      "poi_directions_map_url": "https://maps.google.com/?cid=10965927297486108609&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "novant-health-presbyterian-medical-center",
      "poi_latitude": "35.2117536",
      "poi_longitude": "-80.8244434",
      "poi_miles_from_property": "7.2 mi",
      "poi_walking_minutes": "2 hours 40 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 704-384-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1514-7a99-7298-aac8-8b288921d830.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1514-7a99-7298-aac8-8b288921d830",
        "storage_key": "property/5651440852795392/019f1514-7a99-7298-aac8-8b288921d830.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJMUij1PafVogRwTdr78bMLpg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "ec_b130d304e40b2acd444f0672",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "source": "generator",
      "poi_name": "Charlotte Douglas International Airport",
      "poi_type": "Major Employers & Offices",
      "poi_address": "5501 Josh Birmingham Pkwy, Charlotte, NC 28208, USA",
      "poi_short_description": "Airport with rocking chairs, free WiFi & a 60-foot outdoor sculpture symbolizing flight.",
      "poi_long_description": "Airport with rocking chairs, free WiFi & a 60-foot outdoor sculpture symbolizing flight.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1517-8772-779a-930a-b7b97a116faf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1517-8772-779a-930a-b7b97a116faf",
        "storage_key": "property/5651440852795392/019f1517-8772-779a-930a-b7b97a116faf.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cltairport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1925933632275654455&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "charlotte-douglas-international-airport",
      "poi_latitude": "35.2162994",
      "poi_longitude": "-80.95394280000001",
      "poi_miles_from_property": "15.9 mi",
      "poi_walking_minutes": "5 hours 55 mins",
      "poi_biking_minutes": "1 hour 38 mins",
      "poi_driving_minutes": "25 mins",
      "poi_business_phone": "+1 704-359-4013",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f1517-9ff5-764f-9a41-c781572e5988.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1517-9ff5-764f-9a41-c781572e5988",
        "storage_key": "property/5651440852795392/019f1517-9ff5-764f-9a41-c781572e5988.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJidRKt32YVogRN6fEPG9Kuho",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    }
  ],
  "office_hours": [
    {
      "id": "custom_ae819004-5e19-4cb3-b26a-d01131be20b8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_aa332768-f8c4-4bfb-9fc0-4a7c96d83f99",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_611737c1-e39d-4b3a-a86c-cd503ae8c1dd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_339143cf-485d-4ef1-b1b5-e53e6a51f8c3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_d4411518-a35f-42e4-98db-d9cce38a427f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_4a03c7af-5135-4829-b045-ccad706fc706",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_8957597f-797d-4f25-a760-910618421e83",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "rating": "5.0",
      "name": "",
      "text": "Clean Community.... Professional staff.... Next to the Blue Line Station (University) and in the vicinity of Major shopping  Outlets.  \n'd'",
      "date": "",
      "title": "Nice Location.... Next to the Light Rail Line"
    },
    {
      "id": "custom_82793614-4907-4d13-ab9a-2e97bde782cf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "rating": "5.0",
      "name": "",
      "text": "They offer a great & safe community to live in! The Management Team is superb at V & Three, especially Grant & Latoya! If your looking for a great place to call your home, definitely come check out V & Three!!!",
      "date": "",
      "title": "Nice Community, a great place to live!!!!  "
    },
    {
      "id": "custom_9d49764e-3ddb-4848-9575-19f5b9ccfa63",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "rating": "5.0",
      "name": "",
      "text": "Hanna did an awesome job on getting me and my kids in an apartment. She was very proficient and got the job done immediately. So far so good. Complex looks exactly how it does on pictures. Would recommend if you’re looking for a nice, safe place.  ",
      "date": "",
      "title": "Newly built complex"
    },
    {
      "id": "custom_ed9b3eba-d303-48be-99aa-930f6e14ea72",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "rating": "5.0",
      "name": "",
      "text": "I am surprised at some of these reviews. I have a great experience and the staff have been so friendly and helpful (especially, Patrick my lease agent) I work from home and I don’t hear much day or night. I would recommend, in my personal experience! ",
      "date": "",
      "title": "Love it so far "
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_c7124b331b8651c9a2584f5f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f14c4-d339-75ce-a108-05807faf5e47.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f14c4-d339-75ce-a108-05807faf5e47",
        "storage_key": "property/5651440852795392/019f14c4-d339-75ce-a108-05807faf5e47.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Popular - 2BR,2BA",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=XLuejhJkPh6"
    },
    {
      "id": "ec_e6cfca910c292a65e7b1617d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f14c4-d506-72a8-bec3-ad061bc1b0e3.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f14c4-d506-72a8-bec3-ad061bc1b0e3",
        "storage_key": "property/5651440852795392/019f14c4-d506-72a8-bec3-ad061bc1b0e3.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Fitness Center",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=eYbhxCtyYQM"
    },
    {
      "id": "ec_a1c6befe741f28c61a7d963a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f14c4-d3b7-70ed-926d-3c8349f4eb39.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f14c4-d3b7-70ed-926d-3c8349f4eb39",
        "storage_key": "property/5651440852795392/019f14c4-d3b7-70ed-926d-3c8349f4eb39.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Clubhouse",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=G278RP1FdXR"
    }
  ],
  "faqs": [
    {
      "id": "custom_29901545-d59e-4483-96d0-5c5a096169f2",
      "question": "Is 8 Metro Station pet-friendly?",
      "answer": "Yes. 8 Metro Station welcomes cats and dogs, up to 2 pets per home, with no posted weight limit. Some breed restrictions apply. Assistance animals (service animals and emotional support animals) are not pets under fair housing law, so they are not subject to pet fees, deposits, or breed and weight restrictions. For the full pet policy, call the leasing team at (704) 532-0580 or visit our contact page.",
      "category": "Pet Policy",
      "source": "custom"
    },
    {
      "id": "custom_870819d5-85e4-4d90-90e2-c8aa4b631900",
      "question": "How can I schedule a tour at 8 Metro Station?",
      "answer": "You can schedule a tour of 8 Metro Station online through our Schedule a Tour page, or call the leasing office at (704) 532-0580. You can also view our virtual tours to see the community before visiting in person.",
      "category": "Contact & Tours",
      "source": "custom"
    },
    {
      "id": "custom_7adcbe74-e044-4fab-ad71-6ddde5f4141f",
      "question": "What are the leasing office hours at 8 Metro Station?",
      "answer": "The 8 Metro Station leasing office is open during these hours:\n\n• Monday: 9:00 AM to 6:00 PM\n• Tuesday: 9:00 AM to 6:00 PM\n• Wednesday: 9:00 AM to 6:00 PM\n• Thursday: 9:00 AM to 6:00 PM\n• Friday: 9:00 AM to 6:00 PM\n• Saturday: 10:00 AM to 5:00 PM\n\nHours may change around holidays. Call (704) 532-0580 or visit our contact page to confirm before you visit.",
      "category": "Office Hours",
      "source": "custom"
    },
    {
      "id": "custom_bbc5185f-d15c-475d-aa52-863c026f281d",
      "question": "What floor plans are available at 8 Metro Station?",
      "answer": "8 Metro Station offers 1- to 3-bedroom apartment homes ranging from approximately 707 to 1,698 square feet, across 15 floor plans. View layouts, square footage, and current availability on our Floor Plans page, or schedule a tour to see them in person.",
      "category": "Floor Plans & Units",
      "source": "custom"
    },
    {
      "id": "custom_1f03a62a-2b7d-4229-9dc7-592ff9d1ce4a",
      "question": "What amenities does 8 Metro Station have?",
      "answer": "8 Metro Station offers a range of community and in-home amenities. Community amenities include: LUXER Package Locker, Access Gates, American Landmark 360, Elevators, Fitness Center, Garages, Grill Area, Online Resident Services, Pool, Select Homes, Yoga Room, Lounge, Cyber Cafe, and Tall Ceilings. In-home features include: chef`s kitchen, hard floors, kitchen appliances, kitchen islands, tile backsplash, townhomes, w&d included, walk-in closet, outdoor living, and wrap around patio. See the complete list on our Amenities page.",
      "category": "Amenities & Features",
      "source": "custom"
    },
    {
      "id": "custom_bbdee720-98da-486f-8aad-1306f2ef7e63",
      "question": "Where is 8 Metro Station located?",
      "answer": "8 Metro Station is located at 5025 Wembley Central Ln, Charlotte NC 28213. Nearby you'll find dining at Sabor Latin Street Grill, shopping at El Tigre Mini Super, and green space at Tom Hunter Park. Explore more on our Neighborhood page.",
      "category": "Location & Neighborhood",
      "source": "custom"
    },
    {
      "id": "custom_c3ff1e53-9772-4061-b54a-f5da741f0d15",
      "question": "How do I apply to live at 8 Metro Station?",
      "answer": "You can apply to live at 8 Metro Station online through our Apply Now page, which walks you through each step. If you have questions, the leasing team can help. Call (704) 532-0580 or reach out through our contact page.",
      "category": "Application Process",
      "source": "custom"
    },
    {
      "id": "custom_793ed9e6-8dba-445f-9c14-bce55f7c4632",
      "question": "What do I need to apply at 8 Metro Station?",
      "answer": "Applicants should be ready to provide standard rental application information, including government-issued identification, proof of income, and rental history. Qualification requirements can vary, so we recommend confirming the current criteria with the 8 Metro Station leasing team at (704) 532-0580 or on our contact page. When you're ready, start on the Apply Now page.",
      "category": "Application Process",
      "source": "custom"
    },
    {
      "id": "custom_212e8255-b500-4e2a-b7fa-ce2b27e09e0d",
      "question": "What is the Landmark 360 program at 8 Metro Station?",
      "answer": "8 Metro Station participates in American Landmark's Landmark 360 resident program, which includes three resident promises:\n\n• Move-In Satisfaction Promise: if you are not satisfied within your first 15 days, American Landmark will refund your deposit and waive lease-termination fees.\n• 48-Hour Maintenance Completion Promise: work orders are completed within 48 hours (Monday through Friday), with rent credits if that timeline is missed.\n• Relocation Promise: after six months on your lease, you can transfer to another American Landmark community without penalties, with 60 days' written notice.\nTo learn more, contact the leasing team at (704) 532-0580 or visit our contact page.",
      "category": "Resident Programs",
      "source": "custom"
    },
    {
      "id": "custom_971fdae3-707b-4fa1-b103-c408dffd3255",
      "question": "Does 8 Metro Station have a pool?",
      "answer": "Yes. 8 Metro Station has a swimming pool for residents. See it alongside our other community amenities on the Amenities page.",
      "category": "Amenities & Features",
      "source": "custom"
    },
    {
      "id": "custom_921defda-f898-4794-bf22-4ac748cafe2b",
      "question": "Does 8 Metro Station have a fitness center?",
      "answer": "Yes. 8 Metro Station has a fitness center for residents. See all amenities on the Amenities page, or schedule a tour to view it in person.",
      "category": "Amenities & Features",
      "source": "custom"
    },
    {
      "id": "custom_bb64696f-5fa3-4fa5-becd-1e2b43070b24",
      "question": "Does 8 Metro Station offer virtual tours?",
      "answer": "Yes. 8 Metro Station offers virtual tours of Popular - 2BR,2BA, Fitness Center, and Clubhouse. Start on our Virtual Tours page, then schedule an in-person tour when you are ready.",
      "category": "Contact & Tours",
      "source": "custom"
    },
    {
      "id": "custom_88aa85fd-4c9c-4398-b620-2d31e22dca89",
      "question": "What do residents say about living at 8 Metro Station?",
      "answer": "Residents frequently mention the helpful staff and responsive maintenance at 8 Metro Station. One resident wrote: *\"Clean Community. Professional staff. Next to the Blue Line Station (University) and in the vicinity of Major shopping Outlets.\"* Read more resident reviews on our Reviews page.",
      "category": "Resident Life",
      "source": "custom"
    },
    {
      "id": "custom_e016cc4f-4e57-424f-96ad-54610ae13671",
      "question": "When was 8 Metro Station built?",
      "answer": "8 Metro Station was built in 2019 and renovated in 2021. Schedule a tour to see the finishes in person.",
      "category": "Property History & Features",
      "source": "custom"
    },
    {
      "id": "custom_eef6008d-e54c-4f9e-9c3c-d6d5d6c3dd2a",
      "question": "What is the pet fee at 8 Metro Station?",
      "answer": "Pets at 8 Metro Station: cats and dogs are welcome, up to 2 per home, with no posted weight limit. Some breed restrictions apply. Assistance animals (service animals and emotional support animals) are not pets under fair housing law, so they are not subject to pet fees, deposits, or breed and weight restrictions. For details, contact the leasing team at (704) 532-0580 or visit our contact page.",
      "category": "Pet Policy",
      "source": "custom"
    },
    {
      "id": "custom_fa23ad8e-3a68-4864-b2b9-7872a5c8d4a6",
      "question": "What features are included in the apartments at 8 Metro Station?",
      "answer": "Apartment homes at 8 Metro Station include chef`s kitchen, hard floors, kitchen appliances, kitchen islands, tile backsplash, townhomes, w&d included, walk-in closet, outdoor living, and wrap around patio. Browse layouts on our Floor Plans page or schedule a tour.",
      "category": "Amenities & Features",
      "source": "custom"
    },
    {
      "id": "custom_8d4c7bda-d48a-4e21-a60d-4b6559c12783",
      "question": "What restaurants and shops are near 8 Metro Station?",
      "answer": "Nearby restaurants and shops include Sabor Latin Street Grill, Boardwalk Billy's Raw Bar and Ribs, The Wine Vault, and Famous Toastery. See the full neighborhood guide on our Neighborhood page.",
      "category": "Location & Neighborhood",
      "source": "custom"
    }
  ],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "0198aa45-1f5b-72fc-a1ed-12b5af345a3a",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "8-metro-station",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392"
    },
    {
      "lead_collector_id": "0198aa45-1fbf-724d-b1dc-1cef37e7e736",
      "lead_source": "FACEBOOK_ADS",
      "name": "8-metro-station",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392"
    },
    {
      "lead_collector_id": "0198aa45-2022-7760-86b7-13600f6e80d7",
      "lead_source": "LANDING_PAGE",
      "name": "8-metro-station",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "source": "custom",
      "page_item_url": "apartments-for-rent-near-me-with-fitness-center",
      "search_query": "Apartments For Rent Near Me with Fitness Center",
      "category": "Amenity",
      "h1_title": "Apartments For Rent Near Me with Fitness Center",
      "h2_subtitle": "Stay fit and active at 8 Metro Station, where our apartments feature a state-of-the-art fitness center. Enjoy modern living with easy access to the LYNX Blue Line.",
      "page_copy": "Life comes at you fast, so take the next stop at 8 Metro Station. Our brand-new apartments for rent near me with fitness center are ideally located near NoDa and University City. Stainless-steel appliances, wood-style flooring, and spacious oversized closets are just a few of the upscale features that await. Make Charlotte your urban playground and enjoy our extensive amenities, including a state-of-the-art fitness center, that let you make the most of modern living. Steps from your front door, you’ll have direct access to the train lobby to hop on the LYNX Blue Line when you’re heading out into the city. Experience pure luxury in a prime location at 8 Metro Station.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f6c0b-1cda-771f-80f2-f651d1806fa0.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment building exterior at dusk with dramatic clouds.",
        "public_id": "019f6c0b-1cda-771f-80f2-f651d1806fa0",
        "storage_key": "property/5651440852795392/019f6c0b-1cda-771f-80f2-f651d1806fa0.webp",
        "width": 1920,
        "height": 1281
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f6c0b-2651-71df-a352-cd49b57cf2df.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0b-2651-71df-a352-cd49b57cf2df",
        "storage_key": "property/5651440852795392/019f6c0b-2651-71df-a352-cd49b57cf2df.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "8 Metro Station | Apartments For Rent Near Me with Fitness Center",
      "seo_description": "Discover luxury living at 8 Metro Station. Our apartments for rent near me with fitness center feature upscale finishes and direct access to the LYNX Blue Line.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "source": "custom",
      "page_item_url": "luxury-apartments-charlotte-nc-near-university-city-rent",
      "search_query": "apartments in charlotte nc Near University City for rent",
      "category": "POI",
      "h1_title": "Luxury Apartments in Charlotte NC Near University City for Rent",
      "h2_subtitle": "Discover the upscale living at 8 Metro Station. Our community features spacious 1, 2, and 3 bedroom apartments and townhomes.",
      "page_copy": "Welcome to 8 Metro Station, where luxury meets convenience. Located in Charlotte, NC, our community offers a variety of spacious 1, 2, and 3 bedroom apartments and townhomes near University City. Each unit is designed with modern amenities and high-end finishes to provide you with the ultimate living experience. Enjoy easy access to local dining, shopping, and entertainment options, all just minutes away from your new home. Experience the best of Charlotte living at 8 Metro Station.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f6c0b-1cda-771f-80f2-f651d1806fa0.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment building exterior at dusk with dramatic clouds.",
        "public_id": "019f6c0b-1cda-771f-80f2-f651d1806fa0",
        "storage_key": "property/5651440852795392/019f6c0b-1cda-771f-80f2-f651d1806fa0.webp",
        "width": 1920,
        "height": 1281
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f6c0b-2651-71df-a352-cd49b57cf2df.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0b-2651-71df-a352-cd49b57cf2df",
        "storage_key": "property/5651440852795392/019f6c0b-2651-71df-a352-cd49b57cf2df.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "8 Metro Station | Apartments in Charlotte NC Near University City for Rent",
      "seo_description": "Explore 8 Metro Station's luxury apartments in Charlotte NC near University City for rent. Spacious 1, 2, and 3 bedroom units available. Discover upscale living today.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "source": "custom",
      "page_item_url": "one-bedroom-apartments-for-rent-charlotte-nc",
      "search_query": "One Bedroom Apartments For Rent In Charlotte NC",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments For Rent In Charlotte NC",
      "h2_subtitle": "Discover the luxury of 8 Metro Station's one-bedroom apartments. Located near University City, our community offers spacious living in a prime Charlotte location.",
      "page_copy": "Experience the best of Charlotte living at 8 Metro Station with our one bedroom apartments for rent in Charlotte NC. Our luxury community features spacious floor plans, modern amenities, and a prime location near University City. Each one-bedroom apartment is designed with your comfort in mind, offering high-end finishes, ample storage, and stunning views. Enjoy the convenience of being close to shopping, dining, and entertainment options, all while living in a serene and welcoming environment. Make 8 Metro Station your new home and elevate your lifestyle today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f6c0b-1cda-771f-80f2-f651d1806fa0.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment building exterior at dusk with dramatic clouds.",
        "public_id": "019f6c0b-1cda-771f-80f2-f651d1806fa0",
        "storage_key": "property/5651440852795392/019f6c0b-1cda-771f-80f2-f651d1806fa0.webp",
        "width": 1920,
        "height": 1281
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f6c0b-2651-71df-a352-cd49b57cf2df.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0b-2651-71df-a352-cd49b57cf2df",
        "storage_key": "property/5651440852795392/019f6c0b-2651-71df-a352-cd49b57cf2df.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "8 Metro Station | One Bedroom Apartments For Rent In Charlotte NC",
      "seo_description": "Find luxury one bedroom apartments for rent in Charlotte NC at 8 Metro Station. Enjoy spacious living near University City with modern amenities and prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "source": "custom",
      "page_item_url": "two-bedrooms-apartments-for-rent-charlotte-nc",
      "search_query": "Two Bedrooms Apartments For Rent In Charlotte NC",
      "category": "Floorplan",
      "h1_title": "Two Bedrooms Apartments For Rent In Charlotte NC",
      "h2_subtitle": "Discover the luxury of 8 Metro Station's two-bedroom apartments. Located near University City, our community offers spacious living in a prime location.",
      "page_copy": "Experience the best of Charlotte living with our two bedrooms apartments for rent in Charlotte NC at 8 Metro Station. Our luxury community features spacious two-bedroom apartments designed for comfort and style. Located at 5025 Wembley Central Lane, our apartments are perfect for those seeking a vibrant lifestyle near University City. Enjoy modern amenities, beautiful interiors, and a welcoming community atmosphere. Whether you're a student, professional, or family, 8 Metro Station has the perfect home for you.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f6c0b-1cda-771f-80f2-f651d1806fa0.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment building exterior at dusk with dramatic clouds.",
        "public_id": "019f6c0b-1cda-771f-80f2-f651d1806fa0",
        "storage_key": "property/5651440852795392/019f6c0b-1cda-771f-80f2-f651d1806fa0.webp",
        "width": 1920,
        "height": 1281
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f6c0b-2651-71df-a352-cd49b57cf2df.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0b-2651-71df-a352-cd49b57cf2df",
        "storage_key": "property/5651440852795392/019f6c0b-2651-71df-a352-cd49b57cf2df.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "8 Metro Station | Two Bedrooms Apartments For Rent In Charlotte NC",
      "seo_description": "Explore two bedrooms apartments for rent in Charlotte NC at 8 Metro Station. Luxury living near University City with modern amenities and spacious layouts.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "source": "custom",
      "page_item_url": "three-bedrooms-apartments-for-rent-charlotte-nc",
      "search_query": "Three Bedrooms Apartments For Rent In Charlotte NC",
      "category": "Floorplan",
      "h1_title": "Three Bedrooms Apartments For Rent In Charlotte NC",
      "h2_subtitle": "Discover the luxury of 8 Metro Station's three-bedroom apartments. Experience spacious living near University City in Charlotte, NC.",
      "page_copy": "8 Metro Station features luxurious three-bedroom apartments for rent in Charlotte, NC. Located near University City, our community offers spacious living with modern amenities. Each apartment is designed to provide comfort and style, making it the perfect place to call home. Enjoy the convenience of being close to shopping, dining, and entertainment options, all while living in a serene and upscale environment.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f6c0b-1cda-771f-80f2-f651d1806fa0.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment building exterior at dusk with dramatic clouds.",
        "public_id": "019f6c0b-1cda-771f-80f2-f651d1806fa0",
        "storage_key": "property/5651440852795392/019f6c0b-1cda-771f-80f2-f651d1806fa0.webp",
        "width": 1920,
        "height": 1281
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f6c0b-2651-71df-a352-cd49b57cf2df.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0b-2651-71df-a352-cd49b57cf2df",
        "storage_key": "property/5651440852795392/019f6c0b-2651-71df-a352-cd49b57cf2df.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "8 Metro Station | Three Bedrooms Apartments For Rent In Charlotte NC",
      "seo_description": "Explore 8 Metro Station's three-bedroom apartments for rent in Charlotte, NC. Enjoy luxury living near University City with modern amenities and spacious layouts.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "source": "custom",
      "page_item_url": "apartments-for-rent-charlotte-nc-near-carolinas-hospitalist",
      "search_query": "Apartments For Rent In Charlotte NC Near Carolinas Hospitalist Group",
      "category": "POI",
      "h1_title": "Apartments For Rent In Charlotte NC Near Carolinas Hospitalist Group",
      "h2_subtitle": "Discover luxury living at 8 Metro Station, located near University City. Our spacious 1, 2, and 3 bedroom apartments and townhomes offer unparalleled comfort.",
      "page_copy": "Welcome to 8 Metro Station, your premier destination for apartments for rent in Charlotte NC near Carolinas Hospitalist Group. Our luxury community features spacious 1, 2, and 3 bedroom apartments and townhomes designed to provide you with the utmost comfort and convenience. Located at 5025 Wembley Central Lane, our property is just a short drive from University City, making it an ideal choice for those seeking proximity to work, shopping, and entertainment. Experience the best of Charlotte living with our top-notch amenities and beautifully landscaped grounds. Schedule a tour today and see why 8 Metro Station is the perfect place to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f6c0b-1cda-771f-80f2-f651d1806fa0.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment building exterior at dusk with dramatic clouds.",
        "public_id": "019f6c0b-1cda-771f-80f2-f651d1806fa0",
        "storage_key": "property/5651440852795392/019f6c0b-1cda-771f-80f2-f651d1806fa0.webp",
        "width": 1920,
        "height": 1281
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f6c0b-2651-71df-a352-cd49b57cf2df.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0b-2651-71df-a352-cd49b57cf2df",
        "storage_key": "property/5651440852795392/019f6c0b-2651-71df-a352-cd49b57cf2df.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "8 Metro Station | Apartments For Rent In Charlotte NC Near Carolinas Hospitalist Group",
      "seo_description": "Explore 8 Metro Station for luxury apartments for rent in Charlotte NC near Carolinas Hospitalist Group. Spacious 1, 2, and 3 bedroom options available. Schedule a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "source": "custom",
      "page_item_url": "luxury-apartments-for-rent-charlotte-nc-near-david-g-jacobs",
      "search_query": "Apartments For Rent In Charlotte NC Near David G. Jacobs, MD",
      "category": "POI",
      "h1_title": "Luxury Apartments For Rent In Charlotte NC Near David G. Jacobs, MD",
      "h2_subtitle": "Discover the elegance and convenience of 8 Metro Station. Our community features spacious 1, 2, and 3 bedroom apartments and townhomes near University City.",
      "page_copy": "Welcome to 8 Metro Station, where luxury meets convenience. Our apartments for rent in Charlotte NC near David G. Jacobs, MD, offer a variety of spacious 1, 2, and 3 bedroom floor plans designed to fit your lifestyle. Located in the vibrant University City area, our community features modern amenities and stylish interiors that make coming home a pleasure. Enjoy easy access to top medical facilities, shopping, dining, and entertainment options, all just minutes away from your doorstep. Experience the best of Charlotte living at 8 Metro Station.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f6c0b-1cda-771f-80f2-f651d1806fa0.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment building exterior at dusk with dramatic clouds.",
        "public_id": "019f6c0b-1cda-771f-80f2-f651d1806fa0",
        "storage_key": "property/5651440852795392/019f6c0b-1cda-771f-80f2-f651d1806fa0.webp",
        "width": 1920,
        "height": 1281
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f6c0b-2651-71df-a352-cd49b57cf2df.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0b-2651-71df-a352-cd49b57cf2df",
        "storage_key": "property/5651440852795392/019f6c0b-2651-71df-a352-cd49b57cf2df.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "8 Metro Station | Apartments For Rent In Charlotte NC Near David G. Jacobs, MD",
      "seo_description": "Explore 8 Metro Station's luxury apartments for rent in Charlotte NC near David G. Jacobs, MD. Spacious 1, 2, and 3 bedroom floor plans in University City.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "source": "custom",
      "page_item_url": "apartments-for-rent-charlotte-nc-near-atrium-health",
      "search_query": "Apartments For Rent In Charlotte NC Near Atrium Health Levine Children's Specialty Center",
      "category": "POI",
      "h1_title": "Apartments For Rent In Charlotte NC Near Atrium Health Levine Children's Specialty Center",
      "h2_subtitle": "Discover luxury living at 8 Metro Station, located near University City. Enjoy spacious 1, 2, and 3 bedroom apartments and townhomes in Charlotte, NC.",
      "page_copy": "Welcome to 8 Metro Station, your premier destination for apartments for rent in Charlotte NC near Atrium Health Levine Children's Specialty Center. Our luxury community features spacious 1, 2, and 3 bedroom apartments and townhomes, designed to provide you with the utmost comfort and convenience. Located in the vibrant University City area, 8 Metro Station offers easy access to top dining, shopping, and entertainment options. Experience the best of Charlotte living with our modern amenities and beautifully landscaped grounds. Make 8 Metro Station your new home today and enjoy the perfect blend of luxury and location.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f6c0b-1cda-771f-80f2-f651d1806fa0.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment building exterior at dusk with dramatic clouds.",
        "public_id": "019f6c0b-1cda-771f-80f2-f651d1806fa0",
        "storage_key": "property/5651440852795392/019f6c0b-1cda-771f-80f2-f651d1806fa0.webp",
        "width": 1920,
        "height": 1281
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f6c0b-2651-71df-a352-cd49b57cf2df.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0b-2651-71df-a352-cd49b57cf2df",
        "storage_key": "property/5651440852795392/019f6c0b-2651-71df-a352-cd49b57cf2df.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "8 Metro Station | Apartments For Rent In Charlotte NC Near Atrium Health Levine Children's Specialty Center",
      "seo_description": "Discover 8 Metro Station, offering luxury apartments for rent in Charlotte NC near Atrium Health Levine Children's Specialty Center. Spacious 1, 2, and 3 bedroom options available.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "source": "custom",
      "page_item_url": "apartments-for-rent-charlotte-nc-near-ashley-britton",
      "search_query": "Apartments For Rent In Charlotte NC Near Ashley Britton Christmas, MD",
      "category": "POI",
      "h1_title": "Apartments For Rent In Charlotte NC Near Ashley Britton Christmas, MD",
      "h2_subtitle": "Discover luxury living at 8 Metro Station, located near University City. Our spacious 1, 2, and 3 bedroom apartments and townhomes offer unparalleled comfort.",
      "page_copy": "Welcome to 8 Metro Station, your premier destination for apartments for rent in Charlotte NC near Ashley Britton Christmas, MD. Our luxury community features spacious 1, 2, and 3 bedroom apartments and townhomes designed to provide you with the utmost comfort and convenience. Located in the vibrant University City area, 8 Metro Station offers easy access to shopping, dining, and entertainment options. Enjoy modern amenities, beautifully landscaped grounds, and a welcoming community atmosphere. Experience the best of Charlotte living at 8 Metro Station.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f6c0b-1cda-771f-80f2-f651d1806fa0.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment building exterior at dusk with dramatic clouds.",
        "public_id": "019f6c0b-1cda-771f-80f2-f651d1806fa0",
        "storage_key": "property/5651440852795392/019f6c0b-1cda-771f-80f2-f651d1806fa0.webp",
        "width": 1920,
        "height": 1281
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f6c0b-2651-71df-a352-cd49b57cf2df.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0b-2651-71df-a352-cd49b57cf2df",
        "storage_key": "property/5651440852795392/019f6c0b-2651-71df-a352-cd49b57cf2df.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "8 Metro Station | Apartments For Rent In Charlotte NC Near Ashley Britton Christmas, MD",
      "seo_description": "Discover 8 Metro Station, offering luxury apartments for rent in Charlotte NC near Ashley Britton Christmas, MD. Spacious 1, 2, and 3 bedroom options available.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "source": "custom",
      "page_item_url": "apartments-for-rent-charlotte-nc-near-university-unc",
      "search_query": "Apartments For Rent In Charlotte NC Near University of North Carolina at Charlotte",
      "category": "POI",
      "h1_title": "Apartments For Rent In Charlotte NC Near University of North Carolina at Charlotte",
      "h2_subtitle": "Discover the luxury living at 8 Metro Station. Our spacious 1, 2, and 3 bedroom apartments and townhomes are perfect for students and professionals alike.",
      "page_copy": "Welcome to 8 Metro Station, where luxury meets convenience. Located at 5025 Wembley Central Lane, our community offers a variety of spacious 1, 2, and 3 bedroom apartments and townhomes. Each unit features modern amenities and high-end finishes, making it the ideal place to call home. Situated near University City, 8 Metro Station is perfect for those seeking apartments for rent in Charlotte NC near University of North Carolina at Charlotte. Enjoy easy access to campus, local dining, shopping, and entertainment options. Experience the best of Charlotte living at 8 Metro Station.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f6c0b-1cda-771f-80f2-f651d1806fa0.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment building exterior at dusk with dramatic clouds.",
        "public_id": "019f6c0b-1cda-771f-80f2-f651d1806fa0",
        "storage_key": "property/5651440852795392/019f6c0b-1cda-771f-80f2-f651d1806fa0.webp",
        "width": 1920,
        "height": 1281
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f6c0b-2651-71df-a352-cd49b57cf2df.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0b-2651-71df-a352-cd49b57cf2df",
        "storage_key": "property/5651440852795392/019f6c0b-2651-71df-a352-cd49b57cf2df.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "8 Metro Station | Apartments For Rent In Charlotte NC Near University of North Carolina at Charlotte",
      "seo_description": "Explore 8 Metro Station for luxury apartments for rent in Charlotte NC near University of North Carolina at Charlotte. Spacious 1, 2, and 3 bedroom units available.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "source": "custom",
      "page_item_url": "apartments-for-rent-charlotte-nc-near-wake-forest-business",
      "search_query": "Apartments For Rent In Charlotte NC Near Wake Forest University School of Business Charlotte campus",
      "category": "POI",
      "h1_title": "Apartments For Rent In Charlotte NC Near Wake Forest University School of Business Charlotte campus",
      "h2_subtitle": "Discover luxury living at 8 Metro Station, offering spacious 1, 2, and 3 bedroom apartments and townhomes. Located near University City, our community is perfect for students and professionals.",
      "page_copy": "Welcome to 8 Metro Station, where luxury meets convenience. Our apartments for rent in Charlotte, NC, near Wake Forest University School of Business Charlotte campus, feature spacious 1, 2, and 3 bedroom layouts designed to meet your lifestyle needs. Enjoy modern amenities, a vibrant community, and easy access to University City. Whether you're a student or a professional, 8 Metro Station offers the perfect blend of comfort and convenience. Come experience the best of Charlotte living at 8 Metro Station.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f6c0b-1cda-771f-80f2-f651d1806fa0.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment building exterior at dusk with dramatic clouds.",
        "public_id": "019f6c0b-1cda-771f-80f2-f651d1806fa0",
        "storage_key": "property/5651440852795392/019f6c0b-1cda-771f-80f2-f651d1806fa0.webp",
        "width": 1920,
        "height": 1281
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f6c0b-2651-71df-a352-cd49b57cf2df.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0b-2651-71df-a352-cd49b57cf2df",
        "storage_key": "property/5651440852795392/019f6c0b-2651-71df-a352-cd49b57cf2df.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "8 Metro Station | Apartments For Rent In Charlotte NC Near Wake Forest University School of Business Charlotte campus",
      "seo_description": "Discover 8 Metro Station, offering luxury apartments for rent in Charlotte, NC, near Wake Forest University School of Business Charlotte campus. Perfect for students and professionals.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "source": "custom",
      "page_item_url": "luxury-apartments-rent-charlotte-nc-near-cato-college",
      "search_query": "Apartments For Rent In Charlotte NC Near Cato Middle College High",
      "category": "POI",
      "h1_title": "Luxury Apartments For Rent In Charlotte NC Near Cato Middle College High",
      "h2_subtitle": "Discover the elegance and convenience of 8 Metro Station. Our community features spacious 1, 2, and 3 bedroom apartments and townhomes near University City.",
      "page_copy": "Welcome to 8 Metro Station, where luxury meets convenience. Our apartments for rent in Charlotte, NC, near Cato Middle College High, offer a variety of spacious 1, 2, and 3 bedroom floor plans designed to fit your lifestyle. Located in the vibrant University City area, our community features modern amenities and stylish interiors that make coming home a pleasure. Enjoy easy access to top-rated schools, shopping, dining, and entertainment options, all just minutes away from your doorstep. Experience the best of Charlotte living at 8 Metro Station.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f6c0b-1cda-771f-80f2-f651d1806fa0.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment building exterior at dusk with dramatic clouds.",
        "public_id": "019f6c0b-1cda-771f-80f2-f651d1806fa0",
        "storage_key": "property/5651440852795392/019f6c0b-1cda-771f-80f2-f651d1806fa0.webp",
        "width": 1920,
        "height": 1281
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f6c0b-2651-71df-a352-cd49b57cf2df.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0b-2651-71df-a352-cd49b57cf2df",
        "storage_key": "property/5651440852795392/019f6c0b-2651-71df-a352-cd49b57cf2df.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "8 Metro Station | Apartments For Rent In Charlotte NC Near Cato Middle College High",
      "seo_description": "Explore 8 Metro Station's luxury apartments for rent in Charlotte, NC, near Cato Middle College High. Spacious 1, 2, and 3 bedroom floor plans available.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "source": "custom",
      "page_item_url": "luxury-apartments-rent-charlotte-nc-near-cpcc-merancas",
      "search_query": "Apartments For Rent In Charlotte NC Near Central Piedmont Community College - Merancas Campus",
      "category": "POI",
      "h1_title": "Luxury Apartments For Rent In Charlotte NC Near Central Piedmont Community College - Merancas Campus",
      "h2_subtitle": "Discover the elegance and convenience of 8 Metro Station. Our community features spacious 1, 2, and 3 bedroom apartments and townhomes near University City.",
      "page_copy": "Welcome to 8 Metro Station, where luxury meets convenience. Our apartments for rent in Charlotte, NC, near Central Piedmont Community College - Merancas Campus, offer a variety of spacious 1, 2, and 3 bedroom floor plans. Located at 5025 Wembley Central Lane, our community is designed to provide you with the ultimate living experience. Enjoy modern amenities, a vibrant neighborhood, and easy access to University City. Whether you're a student or a professional, 8 Metro Station is the perfect place to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f6c0b-1cda-771f-80f2-f651d1806fa0.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment building exterior at dusk with dramatic clouds.",
        "public_id": "019f6c0b-1cda-771f-80f2-f651d1806fa0",
        "storage_key": "property/5651440852795392/019f6c0b-1cda-771f-80f2-f651d1806fa0.webp",
        "width": 1920,
        "height": 1281
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f6c0b-2651-71df-a352-cd49b57cf2df.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0b-2651-71df-a352-cd49b57cf2df",
        "storage_key": "property/5651440852795392/019f6c0b-2651-71df-a352-cd49b57cf2df.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "8 Metro Station | Apartments For Rent In Charlotte NC Near Central Piedmont Community College - Merancas Campus",
      "seo_description": "Explore 8 Metro Station's luxury apartments for rent in Charlotte, NC, near Central Piedmont Community College - Merancas Campus. Spacious floor plans and modern amenities await.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "source": "custom",
      "page_item_url": "apartments-for-rent-charlotte-nc-near-governors-village",
      "search_query": "Apartments For Rent In Charlotte NC Near Governor's Village STEM Academy (Lower Campus)",
      "category": "POI",
      "h1_title": "Apartments For Rent In Charlotte NC Near Governor's Village STEM Academy (Lower Campus)",
      "h2_subtitle": "Discover luxury living at 8 Metro Station, located in the heart of Charlotte, NC. Our community features spacious 1, 2, and 3 bedroom apartments and townhomes.",
      "page_copy": "Welcome to 8 Metro Station, where luxury meets convenience. Our apartments for rent in Charlotte NC near Governor's Village STEM Academy (Lower Campus) offer a perfect blend of comfort and style. Choose from our spacious 1, 2, and 3 bedroom apartments and townhomes, each designed with modern amenities to enhance your living experience. Located near University City, 8 Metro Station provides easy access to shopping, dining, and entertainment options. Enjoy the vibrant community and top-notch services that make 8 Metro Station the ideal place to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f6c0b-1cda-771f-80f2-f651d1806fa0.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment building exterior at dusk with dramatic clouds.",
        "public_id": "019f6c0b-1cda-771f-80f2-f651d1806fa0",
        "storage_key": "property/5651440852795392/019f6c0b-1cda-771f-80f2-f651d1806fa0.webp",
        "width": 1920,
        "height": 1281
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f6c0b-2651-71df-a352-cd49b57cf2df.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0b-2651-71df-a352-cd49b57cf2df",
        "storage_key": "property/5651440852795392/019f6c0b-2651-71df-a352-cd49b57cf2df.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "8 Metro Station | Apartments For Rent In Charlotte NC Near Governor's Village STEM Academy (Lower Campus)",
      "seo_description": "Explore 8 Metro Station's luxury apartments for rent in Charlotte NC near Governor's Village STEM Academy (Lower Campus). Spacious 1, 2, and 3 bedroom options available.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "source": "custom",
      "page_item_url": "luxury-apartments-for-rent-charlotte-nc-near-mlk-jr-middle",
      "search_query": "Apartments For Rent In Charlotte NC Near Martin Luther King, Jr. Middle",
      "category": "POI",
      "h1_title": "Luxury Apartments For Rent In Charlotte NC Near Martin Luther King, Jr. Middle",
      "h2_subtitle": "Discover the elegance and convenience of 8 Metro Station. Our community features spacious 1, 2, and 3 bedroom apartments and townhomes near University City.",
      "page_copy": "Welcome to 8 Metro Station, where luxury meets convenience. Our apartments for rent in Charlotte, NC, near Martin Luther King, Jr. Middle, offer a variety of spacious 1, 2, and 3 bedroom floor plans designed to fit your lifestyle. Located at 5025 Wembley Central Lane, our community is just minutes away from University City, providing easy access to shopping, dining, and entertainment options. Experience the best of Charlotte living with our top-notch amenities and beautifully landscaped grounds. Come home to 8 Metro Station and enjoy the perfect blend of comfort and style.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f6c0b-1cda-771f-80f2-f651d1806fa0.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment building exterior at dusk with dramatic clouds.",
        "public_id": "019f6c0b-1cda-771f-80f2-f651d1806fa0",
        "storage_key": "property/5651440852795392/019f6c0b-1cda-771f-80f2-f651d1806fa0.webp",
        "width": 1920,
        "height": 1281
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f6c0b-2651-71df-a352-cd49b57cf2df.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0b-2651-71df-a352-cd49b57cf2df",
        "storage_key": "property/5651440852795392/019f6c0b-2651-71df-a352-cd49b57cf2df.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "8 Metro Station | Apartments For Rent In Charlotte NC Near Martin Luther King, Jr. Middle",
      "seo_description": "Explore 8 Metro Station's luxury apartments for rent in Charlotte, NC, near Martin Luther King, Jr. Middle. Spacious 1, 2, and 3 bedroom floor plans available.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "source": "custom",
      "page_item_url": "apartments-for-rent-charlotte-nc-near-newell-school",
      "search_query": "Apartments For Rent In Charlotte NC Near Newell Elementary School",
      "category": "POI",
      "h1_title": "Apartments For Rent In Charlotte NC Near Newell Elementary School",
      "h2_subtitle": "Discover luxury living at 8 Metro Station, located near University City. Our spacious 1, 2, and 3 bedroom apartments and townhomes offer the perfect blend of comfort and convenience.",
      "page_copy": "Welcome to 8 Metro Station, where luxury meets convenience. Our apartments for rent in Charlotte NC near Newell Elementary School feature spacious 1, 2, and 3 bedroom layouts designed to fit your lifestyle. Located in the vibrant University City area, 8 Metro Station offers easy access to top-rated schools, shopping, dining, and entertainment options. Enjoy modern amenities and a welcoming community atmosphere that makes you feel right at home. Whether you're looking for a cozy one-bedroom or a spacious three-bedroom townhome, 8 Metro Station has the perfect home for you.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f6c0b-1cda-771f-80f2-f651d1806fa0.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment building exterior at dusk with dramatic clouds.",
        "public_id": "019f6c0b-1cda-771f-80f2-f651d1806fa0",
        "storage_key": "property/5651440852795392/019f6c0b-1cda-771f-80f2-f651d1806fa0.webp",
        "width": 1920,
        "height": 1281
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f6c0b-2651-71df-a352-cd49b57cf2df.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0b-2651-71df-a352-cd49b57cf2df",
        "storage_key": "property/5651440852795392/019f6c0b-2651-71df-a352-cd49b57cf2df.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "8 Metro Station | Apartments For Rent In Charlotte NC Near Newell Elementary School",
      "seo_description": "Explore 8 Metro Station's luxury apartments for rent in Charlotte NC near Newell Elementary School. Spacious 1, 2, and 3 bedroom layouts in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "source": "custom",
      "page_item_url": "apartments-for-rent-charlotte-nc-near-julius-chambers-high",
      "search_query": "Apartments For Rent In Charlotte NC Near Julius L. Chambers High School",
      "category": "POI",
      "h1_title": "Apartments For Rent In Charlotte NC Near Julius L. Chambers High School",
      "h2_subtitle": "Discover luxury living at 8 Metro Station, offering spacious 1, 2, and 3 bedroom apartments and townhomes. Located near University City, our community is perfect for you.",
      "page_copy": "Welcome to 8 Metro Station, where luxury meets convenience. Our apartments for rent in Charlotte, NC near Julius L. Chambers High School feature spacious 1, 2, and 3 bedroom layouts designed to fit your lifestyle. Enjoy modern amenities and a prime location near University City, making it easy to access shopping, dining, and entertainment options. At 8 Metro Station, we prioritize your comfort and convenience, providing a serene environment with top-notch facilities. Come and experience the best of Charlotte living at 8 Metro Station.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f6c0b-1cda-771f-80f2-f651d1806fa0.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment building exterior at dusk with dramatic clouds.",
        "public_id": "019f6c0b-1cda-771f-80f2-f651d1806fa0",
        "storage_key": "property/5651440852795392/019f6c0b-1cda-771f-80f2-f651d1806fa0.webp",
        "width": 1920,
        "height": 1281
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f6c0b-2651-71df-a352-cd49b57cf2df.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0b-2651-71df-a352-cd49b57cf2df",
        "storage_key": "property/5651440852795392/019f6c0b-2651-71df-a352-cd49b57cf2df.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "8 Metro Station | Apartments For Rent In Charlotte NC Near Julius L. Chambers High School",
      "seo_description": "Explore 8 Metro Station's luxury apartments for rent in Charlotte, NC near Julius L. Chambers High School. Spacious 1, 2, and 3 bedroom layouts with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "source": "custom",
      "page_item_url": "luxury-apartments-rent-charlotte-nc-near-unc",
      "search_query": "apartments for rent in charlotte nc near UNC Charlotte",
      "category": "POI",
      "h1_title": "Luxury Apartments for Rent in Charlotte NC Near UNC Charlotte",
      "h2_subtitle": "Discover the upscale living at 8 Metro Station, where comfort meets convenience. Our spacious 1, 2, and 3 bedroom apartments and townhomes are perfect for you.",
      "page_copy": "Welcome to 8 Metro Station, your premier destination for luxury apartments for rent in Charlotte NC near UNC Charlotte. Our community features spacious 1, 2, and 3 bedroom apartments and townhomes designed to provide you with the utmost comfort and style. Located in the vibrant University City area, 8 Metro Station offers easy access to UNC Charlotte, making it an ideal choice for students, faculty, and professionals alike. Enjoy modern amenities, a welcoming community, and the convenience of living close to everything you need.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f6c0b-1cda-771f-80f2-f651d1806fa0.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment building exterior at dusk with dramatic clouds.",
        "public_id": "019f6c0b-1cda-771f-80f2-f651d1806fa0",
        "storage_key": "property/5651440852795392/019f6c0b-1cda-771f-80f2-f651d1806fa0.webp",
        "width": 1920,
        "height": 1281
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f6c0b-2651-71df-a352-cd49b57cf2df.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0b-2651-71df-a352-cd49b57cf2df",
        "storage_key": "property/5651440852795392/019f6c0b-2651-71df-a352-cd49b57cf2df.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "8 Metro Station | Apartments for Rent in Charlotte NC Near UNC Charlotte",
      "seo_description": "Explore 8 Metro Station's luxury apartments for rent in Charlotte NC near UNC Charlotte. Spacious 1, 2, and 3 bedroom apartments and townhomes in University City.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "source": "custom",
      "page_item_url": "luxury-apartments-rent-charlotte-nc-near-noda",
      "search_query": "apartments for rent in charlotte nc near NoDa",
      "category": "POI",
      "h1_title": "Luxury Apartments for Rent in Charlotte NC Near NoDa",
      "h2_subtitle": "Discover the upscale living experience at 8 Metro Station. Our community features spacious 1, 2, and 3 bedroom apartments and townhomes near University City.",
      "page_copy": "Welcome to 8 Metro Station, where luxury meets convenience. Our apartments for rent in Charlotte NC near NoDa offer a variety of spacious floor plans, including 1, 2, and 3 bedroom apartments and townhomes. Located near University City, our community features modern amenities and stylish interiors designed to enhance your lifestyle. Enjoy easy access to the vibrant NoDa neighborhood, known for its eclectic mix of art, culture, and dining options. Experience the best of Charlotte living at 8 Metro Station.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f6c0b-1cda-771f-80f2-f651d1806fa0.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment building exterior at dusk with dramatic clouds.",
        "public_id": "019f6c0b-1cda-771f-80f2-f651d1806fa0",
        "storage_key": "property/5651440852795392/019f6c0b-1cda-771f-80f2-f651d1806fa0.webp",
        "width": 1920,
        "height": 1281
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f6c0b-2651-71df-a352-cd49b57cf2df.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0b-2651-71df-a352-cd49b57cf2df",
        "storage_key": "property/5651440852795392/019f6c0b-2651-71df-a352-cd49b57cf2df.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "8 Metro Station | Apartments for Rent in Charlotte NC Near NoDa",
      "seo_description": "Explore 8 Metro Station's luxury apartments for rent in Charlotte NC near NoDa. Offering spacious 1, 2, and 3 bedroom apartments and townhomes near University City.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5651440852795392",
      "source": "custom",
      "page_item_url": "pet-friendly-apartments-rent-charlotte-nc-uptown",
      "search_query": "pet friendly apartments for rent in charlotte nc near Uptown",
      "category": "POI",
      "h1_title": "Pet Friendly Apartments for Rent in Charlotte NC Near Uptown",
      "h2_subtitle": "Discover the luxury living at 8 Metro Station. Our community features spacious 1, 2, and 3 bedroom apartments and townhomes near University City.",
      "page_copy": "Welcome to 8 Metro Station, where luxury meets convenience. Our pet friendly apartments for rent in Charlotte NC near Uptown offer a variety of spacious 1, 2, and 3 bedroom apartments and townhomes. Located at 5025 Wembley Central Lane, our community is designed to provide you with the ultimate living experience. Enjoy modern amenities, a vibrant neighborhood, and easy access to University City. Make 8 Metro Station your new home today and experience the best of Charlotte living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f6c0b-1cda-771f-80f2-f651d1806fa0.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment building exterior at dusk with dramatic clouds.",
        "public_id": "019f6c0b-1cda-771f-80f2-f651d1806fa0",
        "storage_key": "property/5651440852795392/019f6c0b-1cda-771f-80f2-f651d1806fa0.webp",
        "width": 1920,
        "height": 1281
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5651440852795392/019f6c0b-2651-71df-a352-cd49b57cf2df.webp",
      "blank_image_media": {
        "alt_text": "Black square",
        "public_id": "019f6c0b-2651-71df-a352-cd49b57cf2df",
        "storage_key": "property/5651440852795392/019f6c0b-2651-71df-a352-cd49b57cf2df.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "8 Metro Station | Pet Friendly Apartments for Rent in Charlotte NC Near Uptown",
      "seo_description": "8 Metro Station offers pet friendly apartments for rent in Charlotte NC near Uptown. Discover our spacious 1, 2, and 3 bedroom apartments and townhomes near University City.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "jordanh@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "2133"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "2376470949"
    },
    {
      "ID": "custom_leasing_ai",
      "type": "STRING",
      "value": "<script async src=\"https://cdn.leasing.ai/prod/v1/loader.js?pid=69db514f9eb73dfa48ba5a11\"></script>\n<img src=\"https://api.leasing.ai/v1/widgets/pixel/69db514f9eb73dfa48ba5a11\" width=\"1\" height=\"1\" style=\"display:none\" alt=\"\" />"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "4837969"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-5S966B3"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "1"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_betterbot_script",
      "type": "STRING",
      "value": "<script src=\"https://8metrostat.engine.betterbot.com/loader.js\" defer=\"defer\"></script>"
    },
    {
      "ID": "custom_knock_company_id",
      "type": "STRING",
      "value": "3165"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "8443225660"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "1f195820242ac1100a1b122d7087a021"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_engrain_sightmap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/ryzvg5oypln"
    },
    {
      "ID": "custom_self_guided_tour_url",
      "type": "STRING",
      "value": "https://selftournow.com/property/60271292-bca2-42fc-996f-74c8f98bac70"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "custom"
    },
    {
      "ID": "custom_knock_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "704-703-3067"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IjEvcTZHOUN2Q1oxelZFSUxrMGowMnc9PSIsInZhbHVlIjoiZ0FnemVlODFESEZ3bzRzSjVlUWx2Zz09IiwibWFjIjoiNDRlYTY1ZmUzYjE1MjdjMDgyMDNmNDBlM2NiMmZlZmFlOTM2MTEyMjZiMjUwZTg0ZGVkZjhiMDU3OWY1NTcwZiJ9"
    },
    {
      "ID": "custom_household_income_qualification_multiplier",
      "type": "FLOAT",
      "value": "3"
    }
  ],
  "custom_csm": "jordanh@repli360.com",
  "custom_qb_id": "2133",
  "custom_repli_id": "2376470949",
  "custom_leasing_ai": "<script async src=\"https://cdn.leasing.ai/prod/v1/loader.js?pid=69db514f9eb73dfa48ba5a11\"></script>\n<img src=\"https://api.leasing.ai/v1/widgets/pixel/69db514f9eb73dfa48ba5a11\" width=\"1\" height=\"1\" style=\"display:none\" alt=\"\" />",
  "custom_realpage_id": "4837969",
  "custom_google_gtm_id": "GTM-5S966B3",
  "custom_rollout_phase": "1",
  "custom_ads_subscription": "full_stack",
  "custom_betterbot_script": "<script src=\"https://8metrostat.engine.betterbot.com/loader.js\" defer=\"defer\"></script>",
  "custom_knock_company_id": "3165",
  "custom_seo_subscription": "essential",
  "custom_hubspot_company_id": "8443225660",
  "custom_knock_company_token": "1f195820242ac1100a1b122d7087a021",
  "custom_social_subscription": "none",
  "custom_engrain_sightmap_url": "https://sightmap.com/embed/ryzvg5oypln",
  "custom_self_guided_tour_url": "https://selftournow.com/property/60271292-bca2-42fc-996f-74c8f98bac70",
  "custom_website_subscription": "custom",
  "custom_knock_tour_button_popup": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>",
  "custom_ppc_tracking_phone_number": "704-703-3067",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IjEvcTZHOUN2Q1oxelZFSUxrMGowMnc9PSIsInZhbHVlIjoiZ0FnemVlODFESEZ3bzRzSjVlUWx2Zz09IiwibWFjIjoiNDRlYTY1ZmUzYjE1MjdjMDgyMDNmNDBlM2NiMmZlZmFlOTM2MTEyMjZiMjUwZTg0ZGVkZjhiMDU3OWY1NTcwZiJ9",
  "custom_household_income_qualification_multiplier": "3",
  "custom_audioeye_site_id": "ab589087-a9b4-4974-80cf-c4748f0afdb6",
  "custom_audioeye_site_hash": "d70e9642430c969b73a03b2e3ba7c4f7"
};

export const generatedAt = '2026-11-03T20:38:35.183Z';
